import {
  Button,
  Checkbox,
  Col,
  Dropdown,
  Input,
  List,
  message,
  Modal,
  notification,
  Popconfirm,
  Row,
  Spin,
  Tag,
  Typography,
  Popover,
} from 'antd';
import _, { filter, isArray } from 'lodash';
import {
  computed,
  makeObservable,
  observable,
  observe,
  runInAction,
} from 'mobx';
import { observer } from 'mobx-react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React, { Component, createRef, useState } from 'react';
import { withRouter } from 'react-router-dom';
import CustomHeaderCell from 'shared/PitstopUI/PitstopTable/CustomHeaderCell';
import styled from 'styled-components';

import { TableStore } from 'stores/abstract';

import { Link } from 'react-router-dom';

import { ShareVehicleHealthReportPage } from 'containers/ShareVehicleHealthReport';

import { customFleets, PitstopModal } from 'shared';

import {
  AppStore,
  CarStatusStore,
  CarStore,
  ContactStore,
  CurrentUserStore,
  IssueStore,
  ShopStore,
  WorkOrderStore,
} from 'stores';

import {
  renderAssetSafetyInspections,
  renderIssuesWithShowIssuesLink,
  renderNextPMDueInPercentage,
  renderVehicleId,
  renderWorkOrderAssigned,
} from 'containers/CarListTable/CarListTableColumns';

import { renderEngineLightStatus } from 'containers/CarListTable/CarListTableColumnsV2';

import PMFeedbackModal from 'containers/IssueProfile/PMFeedbackModal';

import AddAssetModal from 'components/Modals/AddAssetModal';
import ArchiveAssetModal from 'components/Modals/ArchiveAssetModal';
import NotificationBanner from 'components/NotificationBanner';
import FormFilter from 'components/Vehicles/FormFilter';
import VehicleNoteTextarea from 'components/Vehicles/VehicleNoteTextarea';
import { CardTrailer, CardVehicle } from 'containers/CarCard/CartCardElements';
import { Logger } from 'stores/Classes';
import DeviceStore from 'stores/Classes/DeviceStore';

import AppAlert from 'components/AppAlert';
import FilterDropdown from 'components/FilterDropdown';
import CustomTableColumn from 'components/Tables/CustomTableColumn';
import TableContainer from 'components/Tables/TableContainer';
import DVIRWrapper from 'components/Vehicles/VehiclesTableComponents/DVIRWrapper';
import IndicatorTableWrapper from 'components/Vehicles/VehiclesTableComponents/IndicatorTableWrapper';
import StatusWrapper from 'components/Vehicles/VehiclesTableComponents/StatusWrapper';
import PMTable from './PMTable';
import DebounceSearch from 'components/DebounceSearch';

import { remains } from 'shared/pms';

import {
  dvirFilterOptions,
  engineLightFilterOptions,
  issuesFilterOptions,
  nextPMFilterOptions,
  safetyInspectionsFilterOptions,
} from './VehiclesFiltersHelper';

import {
  calcMileageBack,
  convertHourToSeconds,
} from 'helpers/unitCalculations';

import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  DownCircleOutlined,
  DownOutlined,
  EditOutlined,
  FileTextOutlined,
  PlusOutlined,
  PrinterOutlined,
  ShareAltOutlined,
  FilterFilled,
  FilterOutlined,
} from '@ant-design/icons';
import ExternalIcon from 'assets/icons/external.svg?react';
import { IssuesTable } from 'containers/Issues';
import PitstopModalDarkHeader from 'shared/PitstopUI/PitstopModalDarkHeader';
import VendorsDropdown from './VendorsDropdown';
import WorkOrderTable from 'containers/WorkOrder/WorkOrderTable';
import { EventBus } from 'stores/EventBus';
import { SubLocationSelectionModal } from 'components/Assets/SubLocationSelectionModal';

const Text = Typography.Text;
const { Search, TextArea } = Input;

const StyledPitstopModal = styled(PitstopModalDarkHeader)`
  max-width: ${(props) => (props.device === 'mobile' ? '80%' : 'auto')};

  ${(props) =>
    props.device !== 'mobile' &&
    `
    @media (max-width: 1600px) {
      max-width: 45%;
    }
    @media (min-width: 1601px) {
      max-width: 35%;
    }
  `}
`;

const STATUS_COLORS = [
  '#1890ff', // Blue
  '#52c41a', // Green
  '#faad14', // Yellow
  '#f5222d', // Red
];

const FullWidthRow = styled.tr`
  background: #e6f1ff;
  text-align: center;

  td {
    padding: 10px;
    color: #333;
  }
`;

const DropButton = styled(Button)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: white;
  border-color: ${({ color }) => color || 'inherit'};
  color: ${({ color }) => color || 'inherit'};
  padding: 5px 10px;
  border-radius: 6px;
`;

const StyledDiv = styled.div`
  font-size: 12px;
  padding-top: 5px;
`;
const StyledDivChangedBy = styled.div`
  font-size: 12px;
  padding-top: 0px;
  margin-top: 0px;
`;

const FilterCountBadge = styled.span`
  background-color: #ffffff;
  color: #0038b3;
  border-radius: 10px;
  padding: 0 6px;
  margin-left: 2px;
  font-size: 12px;
`;

const ScrollIndicator = styled.div`
  margin-top: 8px;
  text-align: right;
  color: #8c8c8c;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  svg {
    margin-left: 5px;
    animation: slideRight 1.5s infinite;
  }

  @keyframes slideRight {
    0%,
    100% {
      transform: translateX(0);
    }
    50% {
      transform: translateX(5px);
    }
  }
`;

const StatusDropdown = observer(
  ({
    car,
    currentShopStatuses,
    dropdownVisibility,
    currentShopVendors,
    onVendorUpdate,
    onEditStatusClick,
    onDropdownOpenChange,
    onClickNewStatus,
    carStatusStore,
  }) => {
    const defaultStatuses = carStatusStore.getDefaultStatusList;
    const { device } = DeviceStore;

    const statuses =
      currentShopStatuses?.length === 0 ? defaultStatuses : currentShopStatuses;

    // Determine the current car status
    let currentCarStatus = statuses.find(
      (status) => status.key === car.carStatus
    ) || {
      key: car.carStatus,
      description: 'Status Deleted',
      color: 'grey',
    };

    const showVendorStatus = statuses.filter((status) => status.is_show_vendor);

    if (!statuses.find((status) => status.key === currentCarStatus.key)) {
      currentCarStatus =
        statuses.find((status) => status.is_default) || statuses[0];
    }

    const isShowVendor = showVendorStatus?.length
      ? showVendorStatus.some((status) => status.id === currentCarStatus.id)
      : false;

    const carStatusLatest = car.carStatusLatest;

    const { carStatusSetByFirstName, carStatusSetByLastName } = car;

    const isNotAdmin =
      carStatusSetByFirstName !== 'Admin' || carStatusSetByLastName !== 'Admin';

    const formatted = `Since ${moment(carStatusLatest).format(
      'MMM D, YYYY'
    )} (${moment().diff(moment(carStatusLatest), 'days')} Days)`;

    return (
      <StatusWrapper margin={device === 'mobile' ? '0px' : '5px'}>
        <Dropdown
          trigger={['click']}
          open={dropdownVisibility[car.id]}
          onOpenChange={(flag) => onDropdownOpenChange(car.id, flag)}
          menu={{
            items: [
              ...statuses.map((status) => ({
                key: status.key,
                label: (
                  <Button
                    onClick={(e) => onClickNewStatus(e, status, car)}
                    className="btn-status"
                    ghost
                    style={{
                      color: status.color,
                      backgroundColor: 'white',
                      borderColor: status.color,
                    }}
                  >
                    {status.description}
                  </Button>
                ),
              })),
              {
                type: 'divider',
              },
              {
                key: 'actions',
                label: (
                  <Button
                    block
                    icon={<EditOutlined />}
                    type="primary"
                    onClick={onEditStatusClick}
                  >
                    Edit Statuses
                  </Button>
                ),
              },
            ],
            onClick: (e) => e.domEvent?.stopPropagation(),
          }}
        >
          <DropButton
            onClick={(e) => e.stopPropagation()}
            color={currentCarStatus.color}
            loading={car.isLoadingStatus}
          >
            {currentCarStatus.description} <DownOutlined />
          </DropButton>
        </Dropdown>
        <VendorsDropdown
          car={car}
          vendors={currentShopVendors}
          isShown={isShowVendor}
          shopId={ShopStore.currentShop.id}
          onUpdate={onVendorUpdate}
        />
        {carStatusLatest && <StyledDiv>{formatted}</StyledDiv>}
        {carStatusSetByFirstName && carStatusSetByLastName && isNotAdmin && (
          <StyledDivChangedBy>{`Last changed by ${carStatusSetByFirstName} ${carStatusSetByLastName}`}</StyledDivChangedBy>
        )}
      </StatusWrapper>
    );
  }
);

class VehiclesTable extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object,
    onUpdateCarStatus: PropTypes.func,
    type: PropTypes.string,
    childRef: PropTypes.func,
    loadTotalAssetsCount: PropTypes.func,
  };

  constructor(props) {
    super(props);
    makeObservable(this, {
      tableStore: observable,
      refreshTableOffset: observable,
      shopId: computed,
    });
    // Create a reference to PMTable
    this.pmTableRef = createRef();
    this.vehicleTableRef = createRef();
  }

  tableStore;
  shareVHRCallables;

  state = {
    showShopAssetStatusesModal: false,
    contentType: this.props.type,
    popoverVisible: false,
    customColumns: [],
    shopsColumns: {},
    selectedCarId: undefined,
    vehiclesApiUrl: '',
    issueReportStatus: ['new'],
    currentPagination: {},
    countFiltersSelected: 0,
    shopSettings: null,
    issueSources: [
      'dtc',
      'routine',
      'recall',
      'user',
      'algorithm',
      'archive',
      'lightVehicleDTC',
      'heavyVehicleDTC',
    ],
    isPrintHealthReport: false,
    expandedCards: {},
    dropdownVisibility: {},
    searchKey: null,
    searchValue: null,
    searchTrailerValue: null,
    searchTrailerKey: null,
    connectivityStatus: null,
    maxPriority: _.isNil(
      queryString.parse(this.props.location.search).priorityFilter
    )
      ? 'All'
      : queryString.parse(this.props.location.search).priorityFilter,
    nextPmCars: [],
    isLoadingStatuses: false,
    shopWorkOrderStatuses: [],
    currentShopStatuses: [],
    newShopCarStatuses: [],
    isLoadingData: true,
    isLoadingInitial: true,
    currentShopVendors: [],
    showVendorTitle: false,

    isLoadingVehicles: false,
    currentVehicles: [],
    paginationMeta: {
      pageSize: 10,
      total: 0,
      current: 1,
    },
    dropdownVisible: false,
    currentFilters: [],
    filterOptions: [],
    filteredInfo: {},
    filterByStatusDropdownVisible: false,
    nextPMFilterDropdownVisible: false,
    dvirFilterDropdownVisible: false,
    trailerDvirFilterDropdownVisible: false,
    trailerNextPMFilterDropdownVisible: false,
    currentTrailerDVIRFilters: [],
    currentTrailersPMFilters: [],
    currentPMFilters: [],
    currentDVIRFilters: [],
    currentSafetyFilters: [],
    currentEngineLightFilters: [],
    currentTrailerSafetyFilters: [],
    currentTrailerStatusFilters: [],
    currentIssuesFilters: [],
    currentSubLocationFilters: [],
    currentNonTagsSubLocationFilters: [],
    previousFilters: {},
    currentTrailers: [],
    shouldShowButton: true,
    isArchiveAssetsModalVisible: false,
    expandedCarIds: [],
    selectedAssets: [],
    isArchivingAssets: false,
    archivingAssetType: null,
    isExportingCSV: false,
    safetyInspectionFilterDropdownVisible: false,
    expandedPMCarIds: [],
    expandedSafetyInspectionIds: [],
    subLocationSearchText: '',
    assetsHasTags: false,
    allRecordsRowOption: false,
    selectAll: false,
    isLoadingTableColumns: true,
    expandedWorkOrderCarIds: [],
    subLocationSelectionModalComponent: null,
    subLocationModalVisible: false,
    subLocationModalCarIds: [],
    tableHeight: 600, //FOR STICKY TABLE
    highlightedCarId: null, // For highlighting selected car row when slide-out is open
  };

  get filterOptions() {
    const { currentShopStatuses } = this.state;
    return currentShopStatuses.map((status) => ({
      text: status.description,
      value: status.key,
    }));
  }

  get combinedCurrentFilters() {
    return [
      ...this.state.currentFilters,
      ...this.state.currentPMFilters,
      ...this.state.currentDVIRFilters,
      ...this.state.currentSafetyFilters,
      ...this.state.currentTrailerSafetyFilters,
      ...this.state.currentEngineLightFilters,
      ...this.state.currentIssuesFilters,
      ...this.state.currentSubLocationFilters,
      ...this.state.currentNonTagsSubLocationFilters,
    ];
  }

  refreshTableOffset = false;

  disposer = observe(ShopStore.currentShop, 'id', async () => {
    // load the shop related data
    this.setState({ isLoadingInitial: true, selectedAssets: [] });
    await Promise.all([
      this.loadShopWorkOrderStatuses(),
      this.loadShopStatuses(),
      this.loadShopVendors(),
    ]);
    this.setState({ isLoadingInitial: false });

    // clear the filters that are per shop but keep the generic filters
    this.setState(
      {
        currentFilters: [],
        searchValue: null,
        searchTrailerValue: null,
      },
      () => {
        this.handleOnChangeCurrentFiltersDebouncer();
        this.showOrHideCustomColumns();
      }
    );
  });

  get shopId() {
    return ShopStore.currentShop.id;
  }

  searchDebouncer = null;

  handleSearchData = () => {
    clearTimeout(this.searchDebouncer);

    this.searchDebouncer = setTimeout(() => {
      this.onChangeCurrentFilters();
      if (this.props.type === 'vehicles') {
        if (this.props.onUpdateCarStatus) {
          this.props.onUpdateCarStatus();
        }
      }
    }, 500);
  };

  searchDebouncerTrailers = null;

  addFiltersFromSlideout = (filters) => {
    this.handleCarStatusFilterChange(filters.status, () => {});
    this.handleNextPMFilterChange(filters.pm, () => {});
    this.handleSafetyInspectionFilterChange(filters.safety, () => {});
    this.handleDVIRFilterChange(filters.dvir, () => {});
    this.handleEngineLightFilterChange(filters.light, () => {});
    this.handleIssuesFilterChange(filters.issues, () => {});
    this.handleSubLocationFilterChange(filters.location, () => {});
    this.handleTagLocationFilterChange(filters.tagLocation, () => {});
  };

  handleFilterChange = ({
    selectedKeys,
    confirm,
    filterStateKey,
    options,
    dropdonwVisibleKey,
    callback,
    extraState = {},
  }) => {
    this.setState(
      {
        [filterStateKey]: selectedKeys.map((key) => {
          const option = options.find(
            (s) => s.key === key || s.value === key || s.id === key
          );

          return {
            key: key,
            filterKey: option?.filterKey || key,
            label: option?.code || option?.description || option?.text || key,
            filterType: filterStateKey,
          };
        }),
        [dropdonwVisibleKey]: false,
        selectedAssets: [],
        selectAll: false,
        allRecordsRowOption: false,
        ...extraState,
      },
      () => {
        confirm();
        this.onChangeCurrentFilters();
        if (callback) callback();
      }
    );
  };

  handleFilterReset = ({ clearFilters, filterKey, dropDownKey, callback }) => {
    clearFilters();
    this.setState(
      {
        [filterKey]: [],
        [dropDownKey]: false,
      },
      () => {
        if (callback) callback();
      }
    );
  };

  handleSubLocationFilterChange = (selectedKeys, confirm) => {
    this.handleFilterChange({
      selectedKeys,
      confirm,
      filterStateKey: 'currentNonTagsSubLocationFilters',
      options: ShopStore.shopSettings?.result[0]?.settings?.locations,
      dropdownVisibleKey: 'nonTagsSubLocationFilterDropdownVisible',
    });
  };

  handleTagLocationFilterChange = (selectedKeys, confirm) => {
    const shopId = ShopStore.currentShop.id;

    const allOptions = this.subLocationsFilterOptions(shopId);

    const tagSubLocs = allOptions.filter((option) =>
      option.text
        .toLowerCase()
        .includes(this.state.subLocationSearchText?.toLowerCase() || '')
    );

    this.handleFilterChange({
      selectedKeys,
      confirm,
      filterStateKey: 'currentSubLocationFilters',
      options: tagSubLocs,
      dropdownVisibleKey: 'subLocationFilterDropdownVisible',
    });
  };

  handleCarStatusFilterChange = (selectedKeys, confirm) => {
    this.handleFilterChange({
      selectedKeys,
      confirm,
      filterStateKey: 'currentFilters',
      options: this.state.currentShopStatuses,
      dropdownVisibleKey: 'filterByStatusDropdownVisible',
    });
  };

  handleNextPMFilterChange = (selectedKeys, confirm, callback) => {
    this.handleFilterChange({
      selectedKeys,
      confirm,
      filterStateKey: 'currentPMFilters',
      options: nextPMFilterOptions(),
      dropdownVisibleKey: 'nextPMFilterDropdownVisible',
      callback,
    });
  };

  handleDVIRFilterChange = (selectedKeys, confirm) => {
    this.handleFilterChange({
      selectedKeys,
      confirm,
      filterStateKey: 'currentDVIRFilters',
      options: dvirFilterOptions(),
      dropdownVisibleKey: 'dvirFilterDropdownVisible',
    });
  };

  handleEngineLightFilterChange = (selectedKeys, confirm) => {
    this.handleFilterChange({
      selectedKeys,
      confirm,
      filterStateKey: 'currentEngineLightFilters',
      options: engineLightFilterOptions(),
      dropdownVisibleKey: 'engineLightFilterDropdownVisible',
    });
  };

  handleIssuesFilterChange = (selectedKeys, confirm) => {
    this.handleFilterChange({
      selectedKeys,
      confirm,
      filterStateKey: 'currentIssuesFilters',
      options: issuesFilterOptions(),
      dropdownVisibleKey: 'issuesFilterDropdownVisible',
    });
  };

  handleTrailerSafetyInspectionFilterChange = (selectedKeys, confirm) => {
    this.handleFilterChange({
      selectedKeys,
      confirm,
      filterStateKey: 'currentTrailerSafetyFilters',
      options: safetyInspectionsFilterOptions(),
      dropdownVisibleKey: 'trailerSafetyInspectionFilterDropdownVisible',
    });
  };

  handleReset = (clearFilters, source = 'status') => {
    clearFilters();

    const callback = () => this.onChangeCurrentFilters();

    if (source === 'pm') {
      this.setState(
        {
          currentPMFilters: [],
          nextPMFilterDropdownVisible: false,
        },
        callback
      );
    } else if (source === 'dvir') {
      this.setState(
        {
          currentDVIRFilters: [],
          dvirFilterDropdownVisible: false,
        },
        callback
      );
    } else if (source === 'status') {
      this.setState(
        {
          currentFilters: [],
          filterByStatusDropdownVisible: false,
        },
        callback
      );
    } else if (source === 'engineLight') {
      this.setState(
        {
          currentEngineLightFilters: [],
          engineLightFilterDropdownVisible: false,
        },
        callback
      );
    } else if (source === 'issues') {
      this.setState(
        {
          currentIssuesFilters: [],
          issuesFilterDropdownVisible: false,
        },
        callback
      );
    } else if (source === 'subLocations') {
      this.setState(
        {
          currentSubLocationFilters: [],
          subLocationFilterDropdownVisible: false,
          trailerSubLocationFilterDropdownVisible: false,
          filteredInfo: {
            ...this.state.filteredInfo,
            tagNames: [],
          },
        },
        callback
      );
    } else if (source === 'nonTagsSubLocations') {
      this.setState(
        {
          currentNonTagsSubLocationFilters: [],
          nonTagsSubLocationFilterDropdownVisible: false,
          filteredInfo: {
            ...this.state.filteredInfo,
            nonTagsSubLocations: [],
          },
        },
        callback
      );
    }
  };

  handleTrailerFilterReset = (clearFilters, source = 'dvir') => {
    clearFilters();

    const callback = () => this.onChangeCurrentFilters();

    if (source === 'dvir') {
      this.setState(
        {
          currentTrailerDVIRFilters: [],
          trailerDvirFilterDropdownVisible: false,
        },
        callback
      );
    } else if (source === 'status') {
      this.setState(
        {
          currentTrailerStatusFilters: [],
          trailerFilterByStatusDropdownVisible: false,
        },
        callback
      );
    } else {
      this.setState(
        {
          currentTrailersPMFilters: [],
          trailerNextPMFilterDropdownVisible: false,
        },
        callback
      );
    }
  };

  handleSafetyInspectionFilterReset = (clearFilters, source = 'status') => {
    clearFilters();

    const callback = () => this.onChangeCurrentFilters();

    this.setState(
      {
        currentSafetyFilters: [],
        safetyInspectionFilterDropdownVisible: false,
      },
      callback
    );
  };

  handleSafetyInspectionFilterChange = (selectedKeys, confirm) => {
    this.handleFilterChange({
      selectedKeys,
      confirm,
      filterStateKey: 'currentSafetyFilters',
      options: safetyInspectionsFilterOptions(),
      dropdownVisibleKey: 'safetyInspectionFilterDropdownVisible',
    });
  };

  handleTrailerSafetyInspectionFilterReset = (
    clearFilters,
    source = 'status'
  ) => {
    const callback = this.onChangeCurrentFilters();
    this.handleFilterReset({
      clearFilters,
      filterKey: 'currentTrailerSafetyFilters',
      dropDownKey: 'trailerSafetyInspectionFilterDropdownVisible',
      callback,
    });
  };

  renderTrailerSubLocationsFilterDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => {
    const allOptions = this.subLocationsFilterOptions();
    const filteredOptions = allOptions.filter((option) =>
      option.text
        .toLowerCase()
        .includes(this.state.trailerSubLocationSearchText?.toLowerCase() || '')
    );

    return (
      <FilterDropdown>
        <div style={{ padding: '8px' }}>
          <Input
            placeholder="Search Tags"
            value={this.state.trailerSubLocationSearchText || ''}
            onChange={(e) =>
              this.setState({ trailerSubLocationSearchText: e.target.value })
            }
            style={{ marginBottom: '8px', display: 'block' }}
          />
        </div>
        <div
          className="filter-dropdown-list"
          style={{ maxHeight: '150px', overflowY: 'auto' }}
        >
          {filteredOptions.map((filter) => (
            <div className="filter-dropdown-list-item" key={filter.value}>
              <Checkbox
                checked={selectedKeys?.includes(filter.value)}
                onChange={(e) => {
                  const newKeys = e.target.checked
                    ? [...selectedKeys, filter.value]
                    : selectedKeys.filter((key) => key !== filter.value);
                  setSelectedKeys(newKeys); // Dynamically update selected keys
                }}
              >
                {filter.text}
              </Checkbox>
            </div>
          ))}
        </div>
        <div className="filter-dropdown-actions">
          <Button
            onClick={() => {
              clearFilters(); // Clear the filter keys internally
              setSelectedKeys([]); // Reset selectedKeys
              this.handleReset(clearFilters, 'subLocations'); // Reset external state
            }}
            size="small"
          >
            Reset
          </Button>
          <Button
            type="primary"
            size="small"
            onClick={() => {
              confirm(); // Confirm filter application
              this.handleFilterChange({
                selectedKeys,
                confirm,
                filterStateKey: 'currentSubLocationFilters',
                options: allOptions,
                dropdonwVisibleKey: 'trailerSubLocationFilterDropdownVisible',
              });
            }}
          >
            OK
          </Button>
        </div>
      </FilterDropdown>
    );
  };

  renderNonTagsSubLocationFilterDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => {
    const allLocations =
      ShopStore.shopSettings?.result[0]?.settings?.locations || [];

    return (
      <FilterDropdown>
        <div
          className="filter-dropdown-list"
          style={{ maxHeight: '150px', overflowY: 'auto' }}
        >
          {allLocations.map((location) => (
            <div className="filter-dropdown-list-item" key={location.id}>
              <Checkbox
                checked={selectedKeys.includes(location.id)}
                onChange={(e) => {
                  const newKeys = e.target.checked
                    ? [...selectedKeys, location.id]
                    : selectedKeys.filter((key) => key !== location.id);
                  setSelectedKeys(newKeys);
                }}
              >
                {location.code} - {location.description}
              </Checkbox>
            </div>
          ))}
        </div>
        <div className="filter-dropdown-actions">
          <Button
            onClick={() =>
              this.handleReset(clearFilters, 'nonTagsSubLocations')
            }
            size="small"
          >
            Reset
          </Button>
          <Button
            type="primary"
            size="small"
            onClick={() => {
              this.handleFilterChange({
                selectedKeys,
                confirm,
                filterStateKey: 'currentNonTagsSubLocationFilters',
                options: allLocations,
                dropdonwVisibleKey: 'nonTagsSubLocationFilterDropdownVisible',
              });
            }}
          >
            OK
          </Button>
        </div>
      </FilterDropdown>
    );
  };

  /**
   * Show a modal with a form and the PitstopSelect component where the user can select a sub-location
   * @param {Array} carIds - The car ids
   */
  showSubLocationModal = (carIds) => {
    this.setState({
      subLocationModalVisible: true,
      subLocationModalCarIds: carIds,
    });
  };

  showOrHideCustomColumns = () => {
    const isUfpFleet = customFleets.ufpFleet.includes(
      ShopStore.currentShop.parentShopId || ShopStore.currentShop.id
    );
    const isTimHortonsFleet = customFleets.timhortons.includes(
      ShopStore.currentShop.parentShopId || ShopStore.currentShop.id
    );
    const isEnabledShop = this.state.assetsHasTags;
    if (isEnabledShop || isUfpFleet) {
      // Add `tagNames` column to `vehicleColumns` if not already present
      if (isUfpFleet) {
        this.vehicleColumns = this.vehicleColumns.filter(
          (col) => col.key !== 'nonTagsSubLocations'
        );
        this.trailerColumns = this.trailerColumns.filter(
          (col) => col.key !== 'nonTagsSubLocations'
        );
      }
      if (!this.vehicleColumns.find((col) => col.key === 'tagNames')) {
        this.vehicleColumns.splice(1, 0, {
          key: 'tagNames',
          title: isUfpFleet ? 'Sub Locations' : 'Tags',
          align: 'center',
          sorter: false,
          filters: this.subLocationsFilterOptions(),
          filterDropdown: this.renderSubLocationsFilterDropdown,
          // filterDropdown: null,
          // filterIcon: <span style={{ pointerEvents: 'none' }} />,
          filteredValue: [],
          render: (record) =>
            record?.tags?.length > 0
              ? record.tags.map((tag) => tag.name).join(', ')
              : '-',
          width: 200,
        });
      }

      // Add `tagNames` column to `trailerColumns` if not already present
      if (!this.trailerColumns.find((col) => col.key === 'tagNames')) {
        this.trailerColumns.splice(1, 0, {
          key: 'tagNames',
          title: customFleets.ufpFleet.includes(
            ShopStore.currentShop.parentShopId || ShopStore.currentShop.id
          )
            ? 'Sub Locations'
            : 'Tags',
          align: 'center',
          sorter: false,
          filters: this.subLocationsFilterOptions(),
          filterDropdown: this.renderTrailerSubLocationsFilterDropdown,
          // filterDropdown: null,
          // filterIcon: <span style={{ pointerEvents: 'none' }} />,
          filteredValue: [],
          render: (record) =>
            record?.tags?.length > 0
              ? record.tags.map((tag) => tag.name).join(', ')
              : '-',
          width: 200,
        });
      }
    } else {
      // Remove `tagNames` column if `assetsHasTags` is false
      this.vehicleColumns = this.vehicleColumns.filter(
        (col) => col.key !== 'tagNames'
      );
      this.trailerColumns = this.trailerColumns.filter(
        (col) => col.key !== 'tagNames'
      );

      // always add the nonTagsSubLocationColumn if tags are not enabled for the shop
      const nonTagsSubLocationColumn = {
        key: 'nonTagsSubLocations',
        title: isTimHortonsFleet ? 'Resident Yard' : 'Sub-location',
        align: 'center',
        sorter: false,
        onCell: () => ({
          className: 'hover-effect-cell',
        }),
        // add filtering by sub-location
        // filters: ShopStore.shopSettings?.result[0]?.settings?.locations?.map(
        //   (location) => ({
        //     text: location.code || location.description,
        //     value: location.id,
        //   })
        // ),
        // filterDropdown: this.renderNonTagsSubLocationFilterDropdown,
        filterDropdown: null,
        filteredValue: this.state.filteredInfo?.nonTagsSubLocations || [],
        filterIcon: <span style={{ pointerEvents: 'none' }} />,
        render: (car) => {
          const shopLocations =
            ShopStore.shopSettings?.result[0]?.settings?.locations || [];
          const subLocation = shopLocations.find(
            (location) => location.id === car.meta?.assetLocationId
          );
          const subLocationCodeOrDescription =
            subLocation?.code || subLocation?.description || '--';
          return (
            <div>
              <div>{subLocationCodeOrDescription}</div>
              <Button
                type="link"
                icon={<EditOutlined />}
                onClick={() => this.showSubLocationModal([car.id])}
                style={{ padding: 0, marginTop: 5 }}
              >
                {subLocationCodeOrDescription === '--' ? 'Set' : 'Change'}
              </Button>
            </div>
          );
        },
        width: 200,
      };

      if (
        this.vehicleColumns.find((col) => col.key === 'nonTagsSubLocations')
      ) {
        this.vehicleColumns = this.vehicleColumns.filter(
          (col) => col.key !== 'nonTagsSubLocations'
        );
        this.trailerColumns = this.trailerColumns.filter(
          (col) => col.key !== 'nonTagsSubLocations'
        );
      }
      if (
        !this.vehicleColumns.find((col) => col.key === 'nonTagsSubLocations')
      ) {
        this.vehicleColumns.splice(1, 0, nonTagsSubLocationColumn);
        this.trailerColumns.splice(1, 0, nonTagsSubLocationColumn);
      }
    }

    // Ensure the 'DOT Inspections' column isn't already present in trailerColumns
    if (!this.trailerColumns.find((col) => col.key === 'safetyInspections')) {
      this.trailerColumns.splice(3, 0, {
        key: 'safetyInspections',
        title: 'DOT Inspections',
        width: 200,
        onCell: (record) => {
          return record ? { className: 'hover-effect-cell' } : {};
        },
        sorter: true,
        render: (car) => {
          return renderAssetSafetyInspections(
            car,
            this.handleSafetyInspectionToggle, // Handle the expand/collapse click
            this.state.expandedSafetyInspectionIds // Track expanded state
          );
        },
        // filters: safetyInspectionsFilterOptions(),
        // filterDropdown: this.renderTrailerSafetyInspectionFilterDropdown,
        filterDropdown: null,
        filterIcon: <span style={{ pointerEvents: 'none' }} />,
      });
    }

    // Ensure the 'DOT Inspections' column isn't already present in vehicleColumns
    if (!this.vehicleColumns.find((col) => col.key === 'safetyInspections')) {
      this.vehicleColumns.splice(5, 0, {
        key: 'safetyInspections',
        title: 'DOT Inspections',
        onCell: () => ({
          className: 'hover-effect-cell',
        }),
        sorter: true,
        width: 200,
        render: (car) => {
          return renderAssetSafetyInspections(
            car,
            this.handleSafetyInspectionToggle, // Handle the expand/collapse click
            this.state.expandedSafetyInspectionIds // Track expanded state
          );
        },
        // filters: safetyInspectionsFilterOptions(),
        // filterDropdown: this.renderSafetyInspectionFilterDropdown,
        filterDropdown: null,
        filterIcon: <span style={{ pointerEvents: 'none' }} />,
      });
    }

    // if gobolt, change the car_name column to be Unit ID - Chargers
    if (customFleets.goBolt.includes(ShopStore.currentShop.id)) {
      this.trailerColumns = this.trailerColumns.map((column) => {
        if (column.key === 'car_name') {
          return { ...column, title: 'Unit ID - Chargers' };
        }
        return column;
      });
    } else {
      this.trailerColumns = this.trailerColumns.map((column) => {
        if (column.key === 'car_name') {
          return { ...column, title: 'Unit ID - Trailers' };
        }
        return column;
      });
    }
  };

  saveCarNotes = async ({ id, notes }) => {
    try {
      await CarStore.updateCarNotes(id, notes);
      const updatedVehicles = this.state.currentVehicles.map((vehicle) =>
        vehicle.id === id ? { ...vehicle, notes: notes } : vehicle
      );

      this.setState({ currentVehicles: updatedVehicles });
    } catch (error) {
      AppStore.addError('Failed to save notes');
    }
  };

  renderCarStatusFilterDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => {
    const onReset = () => {
      if (this.props.type === 'vehicles') {
        this.handleReset(clearFilters);
      }

      if (this.props.type === 'trailers') {
        this.handleTrailerFilterReset(clearFilters, 'status');
      }
    };

    const onOk = () => {
      this.handleCarStatusFilterChange(selectedKeys, confirm);
    };

    // if (type === 'vehicles') {
    return (
      <FilterDropdown>
        {/* For each filterOptions display a checkbox and the nase of the filterOptions */}
        <div className="filter-dropdown-list">
          {this.filterOptions.map((filter) => {
            return (
              <div className="filter-dropdown-list-item" key={filter.value}>
                <Checkbox
                  checked={selectedKeys.includes(filter.value)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedKeys([...selectedKeys, filter.value]);
                    } else {
                      setSelectedKeys(
                        selectedKeys.filter((key) => key !== filter.value)
                      );
                    }
                  }}
                >
                  {filter.text}
                </Checkbox>
              </div>
            );
          })}
        </div>
        <div className="filter-dropdown-actions">
          <Button onClick={onReset} size="small">
            Reset
          </Button>
          <Button type="primary" size="small" onClick={onOk}>
            OK
          </Button>
        </div>
      </FilterDropdown>
    );
  };

  handlePmsCountSectionClick = (sectionKey) => {
    this.setState(
      {
        currentPMFilters: [
          {
            key: sectionKey,
            filterKey: sectionKey,
            label: sectionKey === 'overdue' ? 'Overdue' : 'Due Soon',
            filterType: 'currentPMFilters',
          },
        ],
      },
      () => {
        this.handleNextPMFilterChange([sectionKey], () => {});
      }
    );
  };

  handleSafetyInspectionsCountSectionClick = (sectionKey) => {
    this.setState(
      {
        currentSafetyFilters: [
          { key: sectionKey, filterType: 'currentSafetyFilters' },
        ],
      },
      () => {
        this.handleSafetyInspectionFilterChange([sectionKey], () => {});
      }
    );
  };

  handleIssuesCountSectionClick = (sectionKey) => {
    this.setState(
      {
        currentIssuesFilters: [
          {
            key: sectionKey,
            filterKey: sectionKey,
            label: sectionKey.charAt(0).toUpperCase() + sectionKey.slice(1),
            filterType: 'currentIssuesFilters',
          },
        ],
      },
      () => {
        this.handleIssuesFilterChange([sectionKey], () => {});
      }
    );
  };

  handleEngineLightsCountSectionClick = (lightType) => {
    // Map widget light types to filter values
    const lightTypeToFilterValue = {
      stopLamp: 'redStopLamp',
      protectLamp: 'protectWarningLamp',
      milLamp: 'malfunctionLamp',
      checkEngine: 'amberWarningLamp',
    };

    const filterValue = lightTypeToFilterValue[lightType];
    if (!filterValue) return;

    // Find the corresponding filter option to get the display text
    const filterOption = engineLightFilterOptions().find(
      (option) => option.value === filterValue
    );

    this.setState(
      {
        currentEngineLightFilters: [
          {
            key: filterValue,
            filterKey: filterValue,
            label: filterOption?.text || lightType,
            filterType: 'currentEngineLightFilters',
          },
        ],
      },
      () => {
        this.handleEngineLightFilterChange([filterValue], () => {});
      }
    );
  };

  renderNextPMFilterDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => (
    <FilterDropdown>
      {/* For each filterOptions display a checkbox and the name of the filterOptions */}
      <div className="filter-dropdown-list">
        {nextPMFilterOptions().map((filter) => {
          return (
            <div className="filter-dropdown-list-item" key={filter.value}>
              <Checkbox
                checked={selectedKeys.includes(filter.value)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedKeys([...selectedKeys, filter.value]);
                  } else {
                    setSelectedKeys(
                      selectedKeys.filter((key) => key !== filter.value)
                    );
                  }
                }}
              >
                {filter.text}
              </Checkbox>
            </div>
          );
        })}
      </div>
      <div className="filter-dropdown-actions">
        <Button
          onClick={() => this.handleReset(clearFilters, 'pm')}
          size="small"
        >
          Reset
        </Button>
        <Button
          type="primary"
          size="small"
          onClick={() => this.handleNextPMFilterChange(selectedKeys, confirm)}
        >
          OK
        </Button>
      </div>
    </FilterDropdown>
  );

  renderTrailerNextPMFilterDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => (
    <FilterDropdown>
      {/* For each filterOptions display a checkbox and the name of the filterOptions */}
      <div className="filter-dropdown-list">
        {nextPMFilterOptions().map((filter) => {
          return (
            <div className="filter-dropdown-list-item" key={filter.value}>
              <Checkbox
                checked={selectedKeys.includes(filter.value)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedKeys([...selectedKeys, filter.value]);
                  } else {
                    setSelectedKeys(
                      selectedKeys.filter((key) => key !== filter.value)
                    );
                  }
                }}
              >
                {filter.text}
              </Checkbox>
            </div>
          );
        })}
      </div>
      <div className="filter-dropdown-actions">
        <Button
          onClick={() => {
            this.handleTrailerFilterReset(clearFilters, 'nextPm');
            this.handleReset(clearFilters, 'pm');
          }}
          size="small"
        >
          Reset
        </Button>
        <Button
          type="primary"
          size="small"
          onClick={() => this.handleNextPMFilterChange(selectedKeys, confirm)}
        >
          OK
        </Button>
      </div>
    </FilterDropdown>
  );

  subLocationsFilterOptions = () => {
    // Retrieve carShopTags from state
    const { carShopTags } = this.state;

    // If no data, return an empty array
    if (!carShopTags || !carShopTags.data) return [];

    // Map the carShopTags into the desired format
    return carShopTags.data.map((tag) => ({
      text: tag.tag_name, // Display name
      value: tag.tag_name, // Filter key
    }));
  };

  renderSubLocationsFilterDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => {
    // Retrieve current shopId dynamically
    const shopId = ShopStore.currentShop.id;

    // Get the options based on the current shopId
    const allOptions = this.subLocationsFilterOptions(shopId);

    // Filter options based on the search text
    const filteredOptions = allOptions.filter((option) =>
      option.text
        .toLowerCase()
        .includes(this.state.subLocationSearchText?.toLowerCase() || '')
    );

    return (
      <FilterDropdown>
        {/* Search Input */}
        <div style={{ padding: '8px' }}>
          <Input
            placeholder={`Search ${
              customFleets.ufpFleet.includes(
                ShopStore.currentShop.parentShopId || ShopStore.currentShop.id
              )
                ? 'sub-location'
                : 'tag'
            }`}
            value={this.state.subLocationSearchText || ''}
            onChange={(e) =>
              this.setState({ subLocationSearchText: e.target.value })
            }
            style={{ marginBottom: '8px', display: 'block' }}
          />
        </div>
        <div
          className="filter-dropdown-list"
          style={{ maxHeight: '150px', overflowY: 'auto' }}
        >
          {filteredOptions.map((filter) => (
            <div className="filter-dropdown-list-item" key={filter.value}>
              <Checkbox
                checked={selectedKeys.includes(filter.value)}
                onChange={(e) => {
                  const newKeys = e.target.checked
                    ? [...selectedKeys, filter.value]
                    : selectedKeys.filter((key) => key !== filter.value);
                  setSelectedKeys(newKeys);
                }}
              >
                {filter.text}
              </Checkbox>
            </div>
          ))}
        </div>
        <div className="filter-dropdown-actions">
          <Button
            onClick={() => this.handleReset(clearFilters, 'subLocations')}
            size="small"
          >
            Reset
          </Button>
          <Button
            type="primary"
            size="small"
            onClick={() => {
              this.handleFilterChange({
                selectedKeys,
                confirm,
                filterStateKey: 'currentSubLocationFilters',
                options: allOptions,
                dropdonwVisibleKey: 'subLocationFilterDropdownVisible',
              });
            }}
          >
            OK
          </Button>
        </div>
      </FilterDropdown>
    );
  };

  renderSafetyInspectionFilterDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => (
    <FilterDropdown>
      {/* For each filterOptions display a checkbox and the name of the filterOptions */}
      <div className="filter-dropdown-list">
        {safetyInspectionsFilterOptions().map((filter) => {
          return (
            <div className="filter-dropdown-list-item" key={filter.value}>
              <Checkbox
                checked={selectedKeys.includes(filter.value)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedKeys([...selectedKeys, filter.value]);
                  } else {
                    setSelectedKeys(
                      selectedKeys.filter((key) => key !== filter.value)
                    );
                  }
                }}
              >
                {filter.text}
              </Checkbox>
            </div>
          );
        })}
      </div>
      <div className="filter-dropdown-actions">
        <Button
          onClick={() =>
            this.handleSafetyInspectionFilterReset(clearFilters, 'pm')
          }
          size="small"
        >
          Reset
        </Button>
        <Button
          type="primary"
          size="small"
          onClick={() =>
            this.handleSafetyInspectionFilterChange(selectedKeys, confirm)
          }
        >
          OK
        </Button>
      </div>
    </FilterDropdown>
  );

  renderTrailerSafetyInspectionFilterDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => (
    <FilterDropdown>
      {/* For each filterOptions display a checkbox and the name of the filterOptions */}
      <div className="filter-dropdown-list">
        {safetyInspectionsFilterOptions().map((filter) => {
          return (
            <div className="filter-dropdown-list-item" key={filter.value}>
              <Checkbox
                checked={selectedKeys.includes(filter.value)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedKeys([...selectedKeys, filter.value]);
                  } else {
                    setSelectedKeys(
                      selectedKeys.filter((key) => key !== filter.value)
                    );
                  }
                }}
              >
                {filter.text}
              </Checkbox>
            </div>
          );
        })}
      </div>
      <div className="filter-dropdown-actions">
        <Button
          onClick={() =>
            this.handleTrailerSafetyInspectionFilterReset(clearFilters, 'pm')
          }
          size="small"
        >
          Reset
        </Button>
        <Button
          type="primary"
          size="small"
          onClick={() =>
            this.handleTrailerSafetyInspectionFilterChange(
              selectedKeys,
              confirm
            )
          }
        >
          OK
        </Button>
      </div>
    </FilterDropdown>
  );

  renderDVIRFilterDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => (
    <FilterDropdown>
      {/* For each filterOptions display a checkbox and the name of the filterOptions */}
      <div className="filter-dropdown-list">
        {dvirFilterOptions().map((filter) => {
          return (
            <div className="filter-dropdown-list-item" key={filter.value}>
              <Checkbox
                checked={selectedKeys?.includes(filter.value)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedKeys([...selectedKeys, filter.value]);
                  } else {
                    setSelectedKeys(
                      selectedKeys.filter((key) => key !== filter.value)
                    );
                  }
                }}
              >
                {filter.text}
              </Checkbox>
            </div>
          );
        })}
      </div>
      <div className="filter-dropdown-actions">
        <Button
          onClick={() => this.handleReset(clearFilters, 'dvir')}
          size="small"
        >
          Reset
        </Button>
        <Button
          type="primary"
          size="small"
          onClick={() => this.handleDVIRFilterChange(selectedKeys, confirm)}
        >
          OK
        </Button>
      </div>
    </FilterDropdown>
  );

  renderEngineLightFilterDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => (
    <FilterDropdown>
      <div className="filter-dropdown-list">
        {engineLightFilterOptions().map((filter) => {
          return (
            <div className="filter-dropdown-list-item" key={filter.value}>
              <Checkbox
                checked={selectedKeys.includes(filter.value)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedKeys([...selectedKeys, filter.value]);
                  } else {
                    setSelectedKeys(
                      selectedKeys.filter((key) => key !== filter.value)
                    );
                  }
                }}
              >
                {filter.text}
              </Checkbox>
            </div>
          );
        })}
      </div>
      <div className="filter-dropdown-actions">
        <Button
          onClick={() => this.handleReset(clearFilters, 'engineLight')}
          size="small"
        >
          Reset
        </Button>
        <Button
          type="primary"
          size="small"
          onClick={() =>
            this.handleEngineLightFilterChange(selectedKeys, confirm)
          }
        >
          OK
        </Button>
      </div>
    </FilterDropdown>
  );

  renderIssuesFilterDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => (
    <FilterDropdown>
      {/* For each filterOptions display a checkbox and the name of the filterOptions */}
      <div className="filter-dropdown-list">
        {issuesFilterOptions().map((filter) => {
          return (
            <div className="filter-dropdown-list-item" key={filter.value}>
              <Checkbox
                checked={selectedKeys.includes(filter.value)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedKeys([...selectedKeys, filter.value]);
                  } else {
                    setSelectedKeys(
                      selectedKeys.filter((key) => key !== filter.value)
                    );
                  }
                }}
              >
                {filter.text}
              </Checkbox>
            </div>
          );
        })}
      </div>
      <div className="filter-dropdown-actions">
        <Button
          onClick={() => this.handleReset(clearFilters, 'issues')}
          size="small"
        >
          Reset
        </Button>
        <Button
          type="primary"
          size="small"
          onClick={() => this.handleIssuesFilterChange(selectedKeys, confirm)}
        >
          OK
        </Button>
      </div>
    </FilterDropdown>
  );

  renderTrailerDVIRFilterDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => (
    <FilterDropdown>
      {/* For each filterOptions display a checkbox and the name of the filterOptions */}
      <div className="filter-dropdown-list">
        {dvirFilterOptions().map((filter) => {
          return (
            <div className="filter-dropdown-list-item" key={filter.value}>
              <Checkbox
                checked={selectedKeys.includes(filter.value)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedKeys([...selectedKeys, filter.value]);
                  } else {
                    setSelectedKeys(
                      selectedKeys.filter((key) => key !== filter.value)
                    );
                  }
                }}
              >
                {filter.text}
              </Checkbox>
            </div>
          );
        })}
      </div>
      <div className="filter-dropdown-actions">
        <Button
          onClick={() => this.handleReset(clearFilters, 'dvir')}
          size="small"
        >
          Reset
        </Button>
        <Button
          type="primary"
          size="small"
          onClick={() => this.handleDVIRFilterChange(selectedKeys, confirm)}
        >
          OK
        </Button>
      </div>
    </FilterDropdown>
  );

  toggleCardExpansion = (vehicleId) => {
    this.setState((prevState) => ({
      expandedCards: {
        ...prevState.expandedCards,
        [vehicleId]: !prevState.expandedCards[vehicleId],
      },
    }));
  };

  get baseColumns() {
    return {
      car_name: {
        field: 'nextPm',
        key: 'car_name',
        onCell: () => ({
          className: 'hover-effect-cell',
        }),
        title: 'Unit ID',
        sorter: true,
        render: (car) => {
          return renderVehicleId(car, this.state.searchValue);
        },
        width: 200,
      },
      nextPm: {
        field: 'nextPm',
        key: 'percentage',
        filter: false,
        align: 'center',
        title: (
          <div>
            <span>Next PM</span>
          </div>
        ),
        sorter: true,
        onCell: () => ({
          className: 'hover-effect-cell',
        }),
        // filters: nextPMFilterOptions(),
        // filterDropdown: this.renderTrailerNextPMFilterDropdown,
        filterDropdown: null,
        filterIcon: <span style={{ pointerEvents: 'none' }} />,
        render: (car) => {
          return renderNextPMDueInPercentage(
            car,
            this.handleCarPMsToggle,
            this.state.expandedPMCarIds
          );
        },
        width: 200,
      },
      status: {
        field: 'status',
        key: 'car_status',
        title: 'Status',
        align: 'center',
        sorter: true,
        onCell: () => ({
          className: 'hover-effect-cell',
        }),
        // filters: this.filterOptions,
        // filterDropdown: (opt) =>
        //   this.renderCarStatusFilterDropdown(opt, this.state.contentType),
        filterDropdown: null,
        filterIcon: <span style={{ pointerEvents: 'none' }} />,
        render: (car) => (
          <StatusDropdown
            car={car}
            currentShopStatuses={this.state.currentShopStatuses}
            currentShopVendors={this.state.currentShopVendors}
            dropdownVisibility={this.state.dropdownVisibility}
            carStatusStore={CarStatusStore}
            onVendorUpdate={this.handleVendorUpdateForStatusDropDown}
            onEditStatusClick={this.openShopStatusesModal}
            onDropdownOpenChange={this.toggleDropdown}
            onClickNewStatus={this.onClickNewStatus}
          />
        ),
        rowClick: false,
        width: 250,
      },
      workOrder: {
        key: 'workOrderAssigned',
        title: 'Latest Work Order',
        align: 'center',
        onCell: () => ({
          className: 'hover-effect-cell',
        }),
        sorter: false,
        render: (car) => {
          if (car.workOrdersAssigned) {
            return renderWorkOrderAssigned(
              car,
              this.state.shopWorkOrderStatuses,
              this.handleCarWorkOrdersToggle,
              this.state.expandedWorkOrderCarIds
            );
          }
          return 'N/A';
        },
        width: 200,
      },
      notes: {
        field: 'notes',
        key: 'notes',
        filter: false,
        onCell: () => ({
          className: 'hover-effect-cell',
        }),
        align: 'center',
        title: (
          <div>
            <span>Notes</span>
          </div>
        ),
        sorter: false,
        render: (car) => {
          return (
            <VehicleNoteTextarea
              car={car}
              onSave={({ id, notes }) => {
                this.saveCarNotes({ id, notes });
              }}
            />
          );
        },
        rowClick: false,
        width: 250,
      },
    };
  }

  vehicleColumns = [
    // this.baseColumns.indicator,
    { ...this.baseColumns.car_name, ...{ title: 'Unit ID - Vehicles' } },
    this.baseColumns.status,
    {
      key: 'engine_light',
      title: 'Engine Light',
      align: 'center',
      width: 200,
      render: (car) => {
        if (!car.currentEngineLightStatus) {
          return (
            <DVIRWrapper>
              <Spin />
            </DVIRWrapper>
          );
        } else if (car.currentEngineLightStatus === 'not-found') {
          return (
            <DVIRWrapper
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: '10px',
              }}
            >
              <Text>--</Text>
              <Text>--</Text>
              <Text>--</Text>
              <Text>--</Text>
            </DVIRWrapper>
          );
        }
        return renderEngineLightStatus({
          engine_light_status: car?.currentEngineLightStatus?.payload,
          active_from: car?.currentEngineLightStatus?.activationTime,
        });
      },
      sorter: (car1, car2) => {
        return (
          this.mapEngineLightToValue(car1) - this.mapEngineLightToValue(car2)
        );
      },
      // filters: engineLightFilterOptions(),
      // filterDropdown: this.renderEngineLightFilterDropdown,
      filterDropdown: null,
      filterIcon: <span style={{ pointerEvents: 'none' }} />,
    },
    {
      key: 'issues',
      title: 'Issues',
      sorter: true,
      align: 'center',
      width: 200,
      render: (car) =>
        renderIssuesWithShowIssuesLink(
          car,
          this.handleCarIssuesToggle,
          this.state.expandedCarIds
        ),
      // filters: issuesFilterOptions(),
      // filterDropdown: this.renderIssuesFilterDropdown,
      filterDropdown: null,
      filterIcon: <span style={{ pointerEvents: 'none' }} />,
    },
    { ...this.baseColumns.nextPm, width: 200 },
    {
      field: 'dvir',
      key: 'dvir',
      title: 'Latest DVIR',
      align: 'center',
      width: 200,
      sorter: true,
      // filters: dvirFilterOptions(),
      // filterDropdown: this.renderDVIRFilterDropdown,
      filterDropdown: null,
      filterIcon: <span style={{ pointerEvents: 'none' }} />,
      render: (car) => {
        if (!car.dvir) {
          return (
            <DVIRWrapper>
              <Spin />
            </DVIRWrapper>
          );
        }
        const safetyStatus = _.get(car, 'dvir.record.safetyStatus', null);
        if (!safetyStatus) {
          return (
            <DVIRWrapper>
              <Text>--</Text>
            </DVIRWrapper>
          );
        }
        let color;
        let label;
        if (safetyStatus === 'safe') {
          color = 'green';
          label = 'Safe';
        } else if (safetyStatus === 'unsafe') {
          color = 'red';
          label = 'Unsafe';
        } else {
          color = 'geekblue';
          label = 'Resolved';
        }
        const vehicleDefects = _.get(
          car,
          'dvir.record.payload.vehicleDefects',
          []
        );
        const trailerDefects = _.get(
          car,
          'dvir.record.payload.trailerDefects',
          []
        );
        const totalDefects = vehicleDefects?.length + trailerDefects?.length;
        return (
          <DVIRWrapper>
            <div
              className="tag"
              style={{
                color: color,
              }}
              key={car.id}
            >
              {label}
            </div>
            <div className="defects-count">
              Defects: <b>{totalDefects}</b>
            </div>
            <a
              onClick={(evt) => {
                evt.stopPropagation();
                EventBus.$emit('dashboardWrapper/OPEN_SLIDE_OUT', {
                  type: 'dvir',
                  data: {
                    carId: car.id,
                    isTrailer: false,
                  },
                  title: `DVIR - ${car.carName || car.mmy || `Vehicle ${car.id}`}`,
                  selectedCarId: car.id,
                });
              }}
              style={{ marginTop: 5, cursor: 'pointer', color: '#1677ff' }}
            >
              View DVIR
              <ExternalIcon
                style={{ width: '12px', height: '12px', marginLeft: '4px' }}
              />
            </a>
          </DVIRWrapper>
        );
      },
      onCell: (record) => {
        if (!record.dvir || !_.get(record, 'dvir.record.safetyStatus')) {
          return {};
        }
        return { className: 'hover-effect-cell' };
      },
    },
    this.baseColumns.workOrder,
    this.baseColumns.notes,
    {
      field: 'actions',
      key: 'actions',
      filter: false,
      align: 'center',
      onCell: () => ({
        className: 'hover-effect-cell',
      }),
      title: 'Health Report',
      width: 100,
      render: (car) => {
        // return <Button shape="circle" icon="share-alt" />;
        const handleShareClick = (car, { key }) => {
          this.setState({ selectedCarId: car.id }, () => {
            if (key === 'download') {
              this.setState(
                {
                  isPrintHealthReport: false,
                },
                () => {
                  this.onDownloadVehicleHealthReport();
                }
              );
            } else if (key === 'print') {
              this.setState(
                {
                  isPrintHealthReport: true,
                },
                () => {
                  this.onPrintVehicleHealthReport();
                }
              );
            } else if (key === 'share') {
              AppStore.openModals.set(
                'SHARE_VEHICLE_HEALTH_REPORT_MODAL',
                true
              );
            }
          });
        };

        return (
          <Dropdown
            menu={{
              onClick: (data) => {
                handleShareClick(car, data);
              },
              items: [
                {
                  key: 'print',
                  icon: <PrinterOutlined />,
                  label: 'Print Report',
                  onClick: (evt) => {
                    this.stopPropagation(evt);
                  },
                },
                {
                  key: 'download',
                  icon: <DownCircleOutlined />,
                  label: 'Download Report',
                  onClick: (evt) => {
                    this.stopPropagation(evt);
                  },
                },
                {
                  key: 'share',
                  icon: <ShareAltOutlined />,
                  label: 'Share Report',
                  onClick: (evt) => {
                    this.stopPropagation(evt);
                  },
                },
              ],
            }}
            placement="bottomRight"
          >
            <Button
              onClick={(evt) => {
                this.stopPropagation(evt);
              }}
              shape="circle"
              icon={<FileTextOutlined />}
            />
          </Dropdown>
        );
      },
      rowClick: false,
    },
  ];

  trailerColumns = [
    // this.baseColumns.indicator,
    { ...this.baseColumns.car_name, ...{ title: 'Unit ID - Trailers' } },
    this.baseColumns.status,
    this.baseColumns.nextPm,
    {
      field: 'dvir',
      key: 'dvir',
      title: 'Latest DVIR',
      align: 'center',
      sorter: true,
      // filters: dvirFilterOptions(),
      // filterDropdown: this.renderTrailerDVIRFilterDropdown,
      filterDropdown: null,
      filterIcon: <span style={{ pointerEvents: 'none' }} />,
      onCell: () => ({
        className: 'hover-effect-cell',
      }),
      render: (car) => {
        if (!car.dvir) {
          return (
            <DVIRWrapper>
              <Spin />
            </DVIRWrapper>
          );
        }
        const safetyStatus = _.get(car, 'dvir.record.safetyStatus');
        if (!safetyStatus) {
          return (
            <DVIRWrapper>
              <Text>--</Text>
            </DVIRWrapper>
          );
        }
        let color;
        let label;
        if (safetyStatus === 'safe') {
          color = 'green';
          label = 'Safe';
        } else if (safetyStatus === 'unsafe') {
          color = 'red';
          label = 'Unsafe';
        } else {
          color = 'geekblue';
          label = 'Resolved';
        }
        const vehicleDefects = _.get(
          car,
          'dvir.record.payload.vehicleDefects',
          []
        );
        const trailerDefects = _.get(
          car,
          'dvir.record.payload.trailerDefects',
          []
        );
        const totalDefects = vehicleDefects?.length + trailerDefects?.length;
        return (
          <DVIRWrapper>
            <div
              className="tag"
              style={{
                color: color,
              }}
              key={car.id}
            >
              {label}
            </div>
            <div className="defects-count">
              Defects: <b>{totalDefects}</b>
            </div>
            <a
              onClick={(evt) => {
                evt.stopPropagation();
                EventBus.$emit('dashboardWrapper/OPEN_SLIDE_OUT', {
                  type: 'dvir',
                  data: {
                    carId: car.id,
                    isTrailer: true,
                  },
                  title: `DVIR - ${car.carName || car.mmy || `Trailer ${car.id}`}`,
                  selectedCarId: car.id,
                });
              }}
              style={{ marginTop: 5, cursor: 'pointer', color: '#1677ff' }}
            >
              View DVIR
              <ExternalIcon
                style={{ width: '12px', height: '12px', marginLeft: '4px' }}
              />
            </a>
          </DVIRWrapper>
        );
      },
      width: 200,
    },
    this.baseColumns.workOrder,
    this.baseColumns.notes,
  ];

  get columns() {
    return this.props.type === 'vehicles'
      ? this.vehicleColumns
      : this.trailerColumns;
  }

  mapEngineLightToValue = (car) => {
    const engineLightStatus = _.get(car, 'engine_light_status');
    let engineLightValue = 0;
    if (_.isNil(engineLightStatus)) {
      return engineLightValue;
    }
    if (_.get(engineLightStatus, 'generalVehicleWarningLight')) {
      return 2;
    }
    if (_.get(engineLightStatus, 'redStopLamp')) {
      engineLightValue += 6;
    }
    if (_.get(engineLightStatus, 'malfunctionLamp')) {
      engineLightValue += 3;
    }
    if (_.get(engineLightStatus, 'amberWarningLamp')) {
      engineLightValue += 2;
    }
    if (_.get(engineLightStatus, 'protectWarningLamp')) {
      engineLightValue += 2;
    }

    return engineLightValue;
  };

  loadShopStatuses = async () => {
    const shopId = ShopStore.currentShop.id;
    try {
      this.setState({ isLoadingStatuses: true });
      const shopStatuses =
        (await CarStatusStore.fetchShopCarStatuses(shopId)) || [];
      const hasShowVendor = shopStatuses.some(
        (status) => status.is_show_vendor
      );
      this.setState({
        showVendorTitle: hasShowVendor,
        currentShopStatuses: shopStatuses || [],
      });
    } catch (error) {
      Logger.error(error);
    } finally {
      this.setState({ isLoadingStatuses: false });
    }
  };

  loadShopTags = async () => {
    const shopId = this.shopId;
    try {
      this.setState({ isLoadingTags: true });
      const tags = await CarStore.fetchTagsByShopId(shopId);
      this.setState({ carShopTags: tags });
    } catch (error) {
      Logger.error(error);
    } finally {
      this.setState({ isLoadingTags: false });
    }
  };

  loadShopWorkOrderStatuses = async () => {
    const shopId = ShopStore.currentShop.id;
    try {
      this.setState({ isLoadingStatuses: true });
      const shopWorkOrderStatuses =
        await WorkOrderStore.getShopWorkOrderStatuses(shopId);
      this.setState({
        shopWorkOrderStatuses: _.chain(shopWorkOrderStatuses)
          .get('data', [])
          .map((status) => ({
            id: status.id,
            key: status.key,
            name: status.description,
            description: status.description,
            color: status.color,
            text: status.description,
            value: status.key,
            is_default: status.is_default,
          }))
          .value(),
      });
    } catch (error) {
      Logger.error(error);
    } finally {
      this.setState({ isLoadingStatuses: false });
    }
  };

  loadShopVendors = async () => {
    try {
      this.setState({ isLoadingStatuses: true });
      const shopVendors = (await ContactStore.getShopContacts()) || [];

      this.setState({
        currentShopVendors:
          shopVendors.sort((prev, next) => prev.name > next.name) || [],
      });
    } catch (error) {
      Logger.error(error);
    } finally {
      this.setState({ isLoadingStatuses: false });
    }
  };

  saveNewShopStatuses = async () => {
    const shopId = ShopStore.currentShop.id;
    const statuses = this.state.newShopCarStatuses;
    // check if there's a default status
    if (!_.some(statuses, { is_default: true })) {
      message.error('Please select a default status');
      return;
    }
    try {
      this.setState({ isSavingStatuses: true });
      const newStatuses = await CarStatusStore.updateShopStatuses(
        shopId,
        statuses
      );
      this.setState({ currentShopStatuses: newStatuses || [] });
      message.success('Statuses have been updated successfully!');
      this.setState({
        showShopAssetStatusesModal: false,
      });
      if (this.props.onUpdateCarStatus) {
        this.props.onUpdateCarStatus();
      }
    } catch (error) {
      Logger.error(error);
    } finally {
      this.setState({ isSavingStatuses: false });
    }
  };

  stopPropagation = (e) => {
    if (e.stopPropagation) {
      e.stopPropagation();
    } else if (e.domEvent?.stopPropagation) {
      e.domEvent.stopPropagation();
    }
  };

  onClickNewStatus = async (e, status, car) => {
    this.stopPropagation(e);
    const newStatus = status.key;
    const carId = car?.id;
    // update the table with new status
    let toUpdateStatus = {
      currentVehicles: this.state.currentVehicles.map((ccar) => {
        if (ccar.id === carId) {
          ccar.carStatus = newStatus;
          ccar.isLoadingStatus = true;
        }

        return ccar;
      }),
    };

    try {
      // update the car status in the server
      await runInAction(() => CarStore.updateCarStatusOnServer(car, newStatus));
      message.info('Status has been updated successfully!');
      if (this.props.onUpdateCarStatus) {
        this.props.onUpdateCarStatus({
          carId,
          newStatus,
        });
      }

      toUpdateStatus = {
        currentVehicles: this.state.currentVehicles.map((ccar) => {
          if (ccar.id === carId) {
            ccar.isLoadingStatus = false;
          }
          return ccar;
        }),
      };

      this.setState({
        dropdownVisible: false, // Close dropdown
        ...toUpdateStatus,
      });

      this.toggleDropdown(carId, false);
    } catch (error) {
      AppStore.addError('Failed to update status, please try again.');
      Logger.error(error);
    }
  };

  onChangeCurrentFiltersDebouncer = null;

  handleOnChangeCurrentFiltersDebouncer = () => {
    // Clears running timer and starts a new one each time the user types
    clearTimeout(this.onChangeCurrentFiltersDebouncer);
    this.onChangeCurrentFiltersDebouncer = setTimeout(() => {
      this.onChangeCurrentFilters();
    }, 500);
  };

  onChangeCurrentTrailersFiltersDebouncer = null;

  unlisten = null;

  async componentDidMount() {
    if (this.props.childRef && typeof this.props.childRef === 'function') {
      this.props.childRef(this);
    }

    this.setState({ isLoadingInitial: true });

    await Promise.all([
      this.loadShopWorkOrderStatuses(),
      this.loadShopStatuses(),
      this.loadShopVendors(),
      this.loadQueryParamsAndUpdateTable(),
    ]);

    this.setState({ isLoadingInitial: false });

    this.handleOnChangeCurrentFiltersDebouncer();

    this.showOrHideCustomColumns();

    this.unlisten = this.props.history.listen((location, action) => {
      const query = queryString.parse(location.search);

      const updateFilter = (queryKey, filterOptions, stateKey) => {
        const filterValue = query[queryKey];
        if (filterValue) {
          const selectedFilter = filterOptions.find(
            (filter) =>
              filter.value === filterValue ||
              clearString(filter.text) === clearString(filterValue)
          );
          if (selectedFilter) {
            return {
              [stateKey]: [
                {
                  key: selectedFilter.value,
                  label: selectedFilter.text,
                },
              ],
            };
          }
        }
        return null;
      };

      const clearString = (str) => _.deburr(_.kebabCase(str));

      const newState = {
        ...updateFilter('dvir', dvirFilterOptions(), 'currentDVIRFilters'),
        ...updateFilter(
          'dvirTrailer',
          dvirFilterOptions(),
          'currentTrailerDVIRFilters'
        ),
        ...updateFilter('status', this.filterOptions, 'currentFilters'),
        ...updateFilter('pmFilter', nextPMFilterOptions(), 'currentPMFilters'),
      };

      if (Object.keys(newState)?.length > 0) {
        this.setState(newState, this.handleOnChangeCurrentFiltersDebouncer);
      }
    });
    this.showOrHideCustomColumns();

    //STICK TABLE
    const offsetHeight = 64;
    const padding = 16;

    this.setState({
      tableHeight: window.innerHeight - offsetHeight - padding,
    });

    // EventBus events...
    EventBus.$on(
      'workOrders:updateExpandedWorkOrder',
      this.handleUpdateExpandedWorkOrder
    );

    // Listen for work order table refresh events
    EventBus.$on(
      'workOrders:fetchLatestWorkOrdersForCar',
      this.handleFetchLatestWorkOrdersForCar
    );

    // Listen for car row highlight events
    EventBus.$on('dashboardWrapper/HIGHLIGHT_CAR_ROW', (carId) => {
      this.setState({ highlightedCarId: carId });
    });

    EventBus.$on('dashboardWrapper/CLEAR_CAR_ROW_HIGHLIGHT', () => {
      this.setState({ highlightedCarId: null });
    });

    //listen for filter changes
    EventBus.$on('dashboardWrapper/FILTER_CHANGE', (payload) => {
      const { action, filters } = payload;
      switch (action) {
        case 'add':
          // console.log('adding filter', filters);
          this.addFiltersFromSlideout(filters);
          break;
        case 'close':
          // console.log('closing filter', filters);
          this.onCloseFilter(filters);
          break;
        case 'clear':
          // console.log('clearing all filters');
          this.onClearAllFilters();
          break;
        default:
          console.log('Unknown filter action:', action);
          break;
      }
    });
  }

  componentWillUnmount() {
    if (this.disposer) {
      this.disposer();
    }
    if (this.unlisten) {
      this.unlisten();
    }

    // Add cleanup for async operations
    if (this.searchDebouncer) {
      clearTimeout(this.searchDebouncer);
    }
    if (this.onChangeCurrentFiltersDebouncer) {
      clearTimeout(this.onChangeCurrentFiltersDebouncer);
    }
    if (this.searchDebouncerTrailers) {
      clearTimeout(this.searchDebouncerTrailers);
    }

    EventBus.$off(
      'workOrders:updateExpandedWorkOrder',
      this.handleUpdateExpandedWorkOrder
    );

    // Clean up work order table refresh events
    EventBus.$off(
      'workOrders:fetchLatestWorkOrdersForCar',
      this.handleFetchLatestWorkOrdersForCar
    );

    // Clean up car row highlight events
    EventBus.$off('dashboardWrapper/HIGHLIGHT_CAR_ROW');
    EventBus.$off('dashboardWrapper/CLEAR_CAR_ROW_HIGHLIGHT');

    EventBus.$off('dashboardWrapper/FILTER_CHANGE');
  }

  async componentDidUpdate(prevProps, prevState) {
    const searchChanged =
      prevProps.location.search !== this.props.location.search;

    if (searchChanged && this.state.searchKey !== 'carNameOrVinOrLicense') {
      const currentParams = new URLSearchParams(this.props.location.search);
      const prevParams = new URLSearchParams(prevProps.location.search);

      const externalParamChanged =
        currentParams.get('vehicleDvir') !== prevParams.get('vehicleDvir') &&
        !this.filtersMatchURLParams(currentParams);

      if (externalParamChanged) {
        this.handleSearchParamChange();
      }
    }

    if (this.state.searchValue !== prevState.searchValue) {
      console.log(
        'searchValue changed',
        this.state.searchValue,
        prevState.searchValue
      );
      this.handleSearchData();
    }

    if (!searchChanged) {
      this.syncFiltersWithURL(prevState);
    }

    // Handle type prop changes
    if (prevProps.type !== this.props.type) {
      this.setState({ contentType: this.props.type });
      this.handleOnChangeCurrentFiltersDebouncer();
    }
  }

  // updateColumnFilters = () => {
  //   console.log('GOING HERE');
  //   this.vehicleColumns = (this.vehicleColumns || []).map((column) => {
  //     if (column.key === 'car_status') {
  //       return {
  //         ...column,
  //         filters: this.filterOptions,
  //       };
  //     }
  //     return column;
  //   });
  // };

  handleSearchParamChange = () => {
    const searchParams = new URLSearchParams(this.props.location.search);

    const vehicledvir = searchParams.get('vehicleDvir');
    const currentType = searchParams.get('currentType');
    const isTrailer =
      currentType === 'trailers' || this.state.currentType === 'trailer';

    const filtersArray = vehicledvir
      ? vehicledvir.split(',').map((item) => ({
          key: item,
          filterKey: item,
          label: item.charAt(0).toUpperCase() + item.slice(1),
          filterType: 'currentDVIRFilters',
        }))
      : [];

    const nextFilteredInfo = {
      ...this.state.filteredInfo,
      dvirStatus: vehicledvir?.split(','),
    };

    const updateds = {
      currentDVIRFilters: filtersArray,
      filteredInfo: nextFilteredInfo,
    };

    if (isTrailer) {
      updateds.currentTrailerDVIRFilters = filtersArray;
    }

    if (!_.isEqual(updateds, this.state)) {
      this.setState(updateds, this.onChangeCurrentFilters);
    }
  };

  // Helper method to check if current filters match URL parameters
  filtersMatchURLParams = (urlParams) => {
    const vehicleDvir = urlParams.get('vehicleDvir');
    const currentDvirKeys = this.state.currentDVIRFilters
      .map((f) => f.key)
      .join(',');

    // Return true if the URL's vehicleDvir matches current filters
    return (
      vehicleDvir === currentDvirKeys || (!vehicleDvir && !currentDvirKeys)
    );
  };

  syncFiltersWithURL = (prevState) => {
    const { searchValue } = this.state;

    const changed =
      searchValue !== prevState.searchValue ||
      !_.isEqual(this.state.currentFilters, prevState.currentFilters) ||
      !_.isEqual(this.state.currentPMFilters, prevState.currentPMFilters) ||
      !_.isEqual(this.state.currentDVIRFilters, prevState.currentDVIRFilters) ||
      !_.isEqual(
        this.state.currentSafetyFilters,
        prevState.currentSafetyFilters
      );

    if (!changed) return;

    const queryParams = new URLSearchParams();
    queryParams.set(
      'status',
      this.state.currentFilters.map((f) => f.key)
    );
    queryParams.set(
      'vehicleNextPmFilter',
      this.state.currentPMFilters.map((f) => f.filterKey)
    );
    queryParams.set(
      'vehicleDvir',
      this.state.currentDVIRFilters.map((f) => f.key)
    );
    queryParams.set(
      'vehicleSafetyInspections',
      this.state.currentSafetyFilters.map((f) => f.filterKey)
    );
    queryParams.set('vehicleSearch', searchValue || '');

    const newSearch = queryParams.toString();

    if (window.location.search.replace(/^\?/, '') !== newSearch) {
      localStorage.setItem('vehiclesFilters', newSearch);
      this.props.history.push({ search: newSearch });
    }
  };

  handleUpdateExpandedWorkOrder = (expandedWorkOrder) => {
    // Find the car using the car id from the expanded work order's assetId
    const car = this.state.currentVehicles.find(
      (c) => c.id === expandedWorkOrder.id_car
    );

    // If the car is in the visible list
    if (car) {
      const workOrderAssigned = _.get(car, 'workOrdersAssigned[0]', null);
      if (workOrderAssigned && workOrderAssigned.id === expandedWorkOrder.id) {
        // the car didn't change, so we just update the work order
        workOrderAssigned.status = expandedWorkOrder.status;
        workOrderAssigned.assigned_to = expandedWorkOrder.assigned_to;
        workOrderAssigned.invoice_number = expandedWorkOrder.invoice_number;
        workOrderAssigned.w_ord_id = expandedWorkOrder.w_ord_id;
      } else if (
        !workOrderAssigned ||
        workOrderAssigned.id !== expandedWorkOrder.id
      ) {
        // the car changed, so we need to add the new work order to the new car
        car.workOrdersAssigned = car.workOrdersAssigned || [];
        car.workOrdersAssigned.push(expandedWorkOrder);
        // remove the work order from the old car
        const oldCar = this.state.currentVehicles.find((c) => {
          const workOrderAssigned = _.get(c, 'workOrdersAssigned', []);
          return workOrderAssigned.some(
            (workOrder) =>
              workOrder.id === expandedWorkOrder.id &&
              workOrder.id_car !== car.id
          );
        });
        if (oldCar) {
          oldCar.workOrdersAssigned = oldCar.workOrdersAssigned || [];
          oldCar.workOrdersAssigned = oldCar.workOrdersAssigned.filter(
            (wo) => wo.id !== expandedWorkOrder.id
          );
        }
      }
      const currentVehicles = [...this.state.currentVehicles];
      const index = currentVehicles.findIndex((c) => c.id === car.id);
      currentVehicles[index] = car;
      this.setState({ currentVehicles });
    } else {
      // If the car is not in the visible list, we need to remove the work order from any visible car that might have it
      const currentVehicles = this.state.currentVehicles.map((vehicle) => {
        if (vehicle.workOrdersAssigned) {
          vehicle.workOrdersAssigned = vehicle.workOrdersAssigned.filter(
            (wo) => wo.id !== expandedWorkOrder.id
          );
        }
        return vehicle;
      });
      this.setState({ currentVehicles });
    }
  };

  handleFetchLatestWorkOrdersForCar = async () => {
    try {
      const { currentVehicles } = this.state;

      if (!_.isEmpty(currentVehicles)) {
        const carIds = _.map(currentVehicles, 'id');
        const workOrders = await WorkOrderStore.searchWorkOrders({
          carIds: carIds.join(','),
        });

        // Update each car with its assigned work orders
        const updatedVehicles = currentVehicles.map((car) => {
          const workOrdersAssigned = _.filter(workOrders, { id_car: car.id });
          if (workOrdersAssigned && workOrdersAssigned.length) {
            car.workOrdersAssigned = workOrdersAssigned;
          } else {
            car.workOrdersAssigned = [];
          }
          return car;
        });

        this.setState({ currentVehicles: updatedVehicles });
      }
    } catch (error) {
      console.error('Error fetching latest work orders for cars:', error);
    }
  };

  loadQueryParamsAndUpdateTable = () => {
    return new Promise((resolve) => {
      const queryParams = new URLSearchParams(
        localStorage.getItem('vehiclesFilters')
      );
      const urlParams = new URLSearchParams(this.props.location.search);
      const formattedCurrentFilters = (stringKeys) =>
        stringKeys?.split(',').map((key) => ({
          key,
          filterKey: key,
          label:
            this.filterOptions.find(
              (option) => String(option.value) === String(key)
            )?.text || key,
          filterType: 'currentFilters',
        }));
      const formattedCurrentPMFilters = (stringKeys) =>
        stringKeys?.split(',').map((key) => ({
          key,
          filterKey: key,
          label:
            nextPMFilterOptions().find(
              (option) => String(option.value) === String(key)
            )?.text || key,
          filterType: 'currentPMFilters',
        }));
      const formattedCurrentDVIRFilters = (stringKeys) =>
        stringKeys?.split(',').map((key) => ({
          key,
          filterKey: key,
          label:
            dvirFilterOptions().find(
              (option) => String(option.value) === String(key)
            )?.text || key,
          filterType: 'currentDVIRFilters',
        }));
      const formattedCurrentSafetyFilters = (stringKeys) =>
        stringKeys?.split(',').map((key) => ({
          key,
          filterKey: key,
          label:
            safetyInspectionsFilterOptions().find(
              (option) => String(option.value) === String(key)
            )?.text || key,
          filterType: 'currentSafetyFilters',
        }));

      this.setState(
        {
          currentFilters: queryParams.get('status')
            ? formattedCurrentFilters(queryParams.get('status'))
            : [],
          currentPMFilters: queryParams.get('vehicleNextPmFilter')
            ? formattedCurrentPMFilters(queryParams.get('vehicleNextPmFilter'))
            : urlParams.get('pmFilter') === 'overdue'
              ? formattedCurrentPMFilters('overdue')
              : [],
          currentDVIRFilters: queryParams.get('vehicleDvir')
            ? formattedCurrentDVIRFilters(queryParams.get('vehicleDvir'))
            : [],
          currentSafetyFilters: queryParams.get('vehicleSafetyInspections')
            ? formattedCurrentSafetyFilters(
                queryParams.get('vehicleSafetyInspections')
              )
            : [],
          searchValue: queryParams.get('vehicleSearch') || '',
          searchKey: queryParams.get('vehicleSearch')
            ? 'carNameOrVinOrLicense'
            : null,
        },
        () => {
          // update the table with the current filters applied
          resolve();
        }
      );
    });
  };

  handleTableChange = (pagination, _filters, sorter) => {
    let column = null;
    const offset = (pagination.current - 1) * pagination.pageSize;

    if (sorter.columnKey) {
      let sortString = sorter.columnKey;
      const sortColumn = _.filter(this.columns, (el) => {
        return sorter.columnKey === (el.sortLabel || el.dataIndex || el.key);
      })[0];

      if (!_.isNil(sortColumn)) {
        sortString =
          sortColumn.sortLabel || sortColumn.dataIndex || sortColumn.key;
      }

      if (!sorter.order) {
        column = undefined;
      } else {
        column = sorter.order === 'ascend' ? `${sortString}` : `-${sortString}`;
      }
    }

    const filters = { ...this.state.filteredInfo };

    // if filtering by engine light, we need to change the filter key to engineLightStatus
    // if (filters.engine_light) {
    //   filters.engineLightStatus = filters.engine_light;
    //   delete filters.engine_light;
    // }

    const params = {
      offset,
      limit: pagination.pageSize,
      sort: column,
      filter: {
        exclude: 'issueList',
        ...filters,
      },
    };

    this.setState({
      currentPagination: pagination,
    });

    this.loadData(this.props.type, params);
  };

  handleCardsChange = (pagination) => {
    const offset = (pagination.page - 1) * pagination.pageSize;

    const params = {
      offset,
      limit: pagination.pageSize,
    };

    this.setState({
      currentPagination: pagination,
    });

    this.loadData(this.props.type, params);
  };

  updateColumnFilters = (columns, filters, filterOptions) => {
    return (columns || []).map((column) => {
      const filterMapping = {
        car_status: {
          // filters: filterOptions,
          filteredValue: filters['car_status'] || [],
        },
        percentage: {
          filteredValue: filters['nextPmFilter'].map(_.camelCase) || [],
        },
        dvir: {
          filteredValue: filters['dvirStatus'] || [],
        },
        safetyInspections: {
          filteredValue: filters['safetyNextPmFilter'].map(_.camelCase) || [],
        },
        engine_light: {
          filteredValue: filters['engineLightStatus'] || [],
        },
        issues: {
          filteredValue: filters['issues'] || [],
        },
        tagNames: {
          filteredValue: filters['tagNames'] || [],
        },
        nonTagsSubLocations: {
          filteredValue: filters['nonTagsSubLocations'] || [],
        },
      };

      return { ...column, ...filterMapping[column.key] };
    });
  };

  onChangeCurrentFilters = () => {
    // update table filter based on currentFilters
    const filters = {
      car_status: [],
      nextPmFilter: [],
      dvirStatus: [],
      safetyNextPmFilter: [],
      engineLightStatus: [],
      issues: [],
      tagNames: [],
      nonTagsSubLocations: [],
    };
    this.state.currentFilters.forEach((filter) => {
      filters['car_status'].push(filter.key);
    });
    this.state.currentPMFilters.forEach((filter) => {
      filters['nextPmFilter'].push(filter.filterKey);
    });
    this.state.currentDVIRFilters.forEach((filter) => {
      filters['dvirStatus'].push(filter.key);
    });
    this.state.currentSafetyFilters.forEach((filter) => {
      filters['safetyNextPmFilter'].push(filter.filterKey);
    });
    this.state.currentTrailerSafetyFilters.forEach((filter) => {
      filters['safetyNextPmFilter'].push(filter.filterKey);
    });
    this.state.currentEngineLightFilters.forEach((filter) => {
      filters['engineLightStatus'].push(filter.filterKey);
    });
    this.state.currentIssuesFilters.forEach((filter) => {
      filters['issues'].push(filter.filterKey);
    });
    this.state.currentSubLocationFilters.forEach((filter) => {
      filters['tagNames'].push(filter.filterKey);
    });
    this.state.currentNonTagsSubLocationFilters.forEach((filter) => {
      filters['nonTagsSubLocations'].push(filter.filterKey);
    });

    EventBus.$emit(
      'dashboardWrapper/UPDATE_FILTERS',
      this.combinedCurrentFilters
    );

    this.setState({ filteredInfo: filters });
    // update the columns
    if (this.props.type === 'vehicles') {
      this.vehicleColumns = this.updateColumnFilters(
        this.vehicleColumns,
        filters,
        this.filterOptions
      );
    } else {
      this.trailerColumns = this.updateColumnFilters(
        this.trailerColumns,
        filters,
        this.filterOptions
      );
    }

    this.loadData(this.props.type, {
      filter: filters,
    });
  };

  asyncGetCarsEngineLightStatus = async () => {
    try {
      const engineLightStatuses = await CarStore.fetchEngineLightStatusForCars(
        _.map(this.state.currentVehicles, 'vin')
      );
      this.setState({
        currentVehicles: this.state.currentVehicles.map((car) => {
          const carEngineLightStatus = _.find(engineLightStatuses.data, {
            vin: car.vin,
          });
          car.currentEngineLightStatus = carEngineLightStatus || 'not-found';
          return car;
        }),
      });
    } catch (error) {
      this.setState({
        currentVehicles: this.state.currentVehicles.map((car) => {
          car.currentEngineLightStatus = 'not-found';
          return car;
        }),
      });
      Logger.error(error);
    }
  };

  asyncGetDVIR = async (vehiclesIds) => {
    try {
      let isTrailer = false;
      if (this.props.type === 'trailers') {
        isTrailer = true;
      }

      Logger.log(
        `fetching dvir for cars ${vehiclesIds} isTrailer: ${isTrailer}`
      );

      const dvirData = await CarStore.fetchDVIRsForCars(vehiclesIds, isTrailer);

      _.delay(() => {
        this.setState((prevState) => ({
          currentVehicles: prevState.currentVehicles.map((car) => {
            return {
              ...car,
              dvir: _.find(dvirData, { carId: car.id }),
            };
          }),
        }));
      }, 1000);
    } catch (error) {
      Logger.log(`error fetching dvir for cars ${vehiclesIds}`, error);
      this.setState({
        currentVehicles: this.state.currentVehicles.map((car) => {
          car.dvir = null;
          return car;
        }),
      });
      Logger.error(error);
    }
  };

  asyncGetNextPM = async (vehiclesIds) => {
    try {
      const nextPMData = await CarStore.getPmScheduleSummaries(vehiclesIds);
      this.setState({
        currentVehicles: this.state.currentVehicles.map((car) => {
          car.nextPm = _.find(nextPMData, { carId: car.id });
          return car;
        }),
      });
    } catch (error) {
      this.setState({
        currentVehicles: this.state.currentVehicles.map((car) => {
          car.nextPm = null;
          return car;
        }),
      });
      Logger.error(error);
    }
  };

  asyncGetColumns = async (vehiclesIds) => {
    try {
      const columnsData = await ShopStore.getCustomColumns(
        this.shopId,
        vehiclesIds
      );

      const {
        data: { columns, cars },
      } = columnsData;

      if (Object.keys(columns).length === 0) {
        return;
      }

      const columnsTitles = {};
      Object.entries(columns).forEach(([key, value]) => {
        columnsTitles[key] = value;
      });

      this.setState({
        shopsColumns: {
          ...this.state.shopsColumns,
          ...columnsTitles,
        },
      });

      this.setState({
        currentVehicles: this.state.currentVehicles.map((car) => {
          const carId = car.id;
          const carColumns = cars[carId];

          const keys = Object.keys(carColumns);

          if (keys.length) {
            keys.forEach((key) => {
              car[key] = carColumns[key];
            });
          }

          return car;
        }),
      });
    } catch (error) {
      Logger.error(error);
    }
  };

  trailerTableStore = new TableStore();

  loadData = async (type, filters = null) => {
    try {
      this.setState({
        customColumns: [],
        shopsColumns: {},
        selectedAssets: [],
        isLoadingData: true,
        dropdownVisibility: [],
      });

      if (_.isNil(filters)) {
        filters = {
          offset: 0,
          limit: 10,
          sort: null,
          filter: {},
        };
      }

      filters.offset = filters.offset || 0;
      filters.limit = filters.limit || 10;

      _.set(filters, 'filter.exclude', 'issueList');
      _.set(
        filters,
        'filter.car_type',
        type === 'vehicles' ? 'vehicle' : 'trailer'
      );

      const { searchValue, searchKey } = this.state;

      if (!_.isNil(searchValue)) {
        filters.filter = {
          ...filters.filter,
          [searchKey]: searchValue,
        };
      }

      const { searchVinValue, searchVin } = this.state;
      if (!_.isNil(searchVinValue)) {
        filters.filter = {
          ...filters.filter,
          [searchVin]: searchVinValue,
        };
      }

      const queryString = new URLSearchParams(filters.filter);
      if (filters.sort) queryString.set('sort', filters.sort);
      if (filters.offset) queryString.set('offset', filters.offset);
      if (filters.limit) queryString.set('limit', filters.limit);

      this.setState({ vehiclesApiUrl: queryString.toString() });

      const cleanFilterIfEmpty = (key) => {
        if (!filters.filter[key]) {
          delete filters.filter[key];
        }
        if (
          filters.filter[key] &&
          (!_.isArray(filters.filter[key]) || filters.filter[key]?.length === 0)
        ) {
          delete filters.filter[key];
        }
      };

      [
        'car_status',
        'nextPmFilter',
        'safetyNextPmFilter',
        'dvirStatus',
        'tagNames',
        'nonTagsSubLocations',
      ].forEach(cleanFilterIfEmpty);

      if (['percentage', '-percentage'].includes(_.get(filters, 'sort'))) {
        const sortDirection = _.get(filters, 'sort');
        filters.sortPm =
          sortDirection[0] === '-' ? 'percentage' : '-percentage';
        delete filters.sort;
      }

      if (
        ['safetyInspections', '-safetyInspections'].includes(
          _.get(filters, 'sort')
        )
      ) {
        const sortDirection = _.get(filters, 'sort');
        filters.sortSafetyPm =
          sortDirection[0] === '-' ? 'percentage' : '-percentage';
        delete filters.sort;
      }

      if (_.get(filters, 'filter.percentage', null)) {
        filters.filter.nextPmFilter = filters?.filter?.percentage?.map(
          (filter) =>
            [
              'overdue',
              'dueSoon',
              'onTrack',
              'noActionNeeded',
              'setupPm',
            ].includes(filter)
              ? {
                  overdue: 'Overdue',
                  dueSoon: 'Due soon',
                  onTrack: 'On Track',
                  upcoming: 'Upcoming',
                  noActionNeeded: 'No action needed',
                  setupPm: 'Setup PM',
                }[filter]
              : filter
        );
        delete filters.filter.percentage;
      }

      if (_.get(filters, 'filter.safetyInspections', null)) {
        filters.filter.safetyNextPmFilter =
          filters.filter.safetyInspections.map((filter) =>
            [
              'overdue',
              'dueSoon',
              'inCompliance',
              'upcoming',
              'noActionNeeded',
            ].includes(filter)
              ? {
                  overdue: 'Overdue',
                  dueSoon: 'Due soon',
                  inCompliance: 'In Compliance',
                  upcoming: 'Upcoming',
                  noActionNeeded: 'No action needed',
                }[filter]
              : filter
          );
        delete filters.filter.safetyInspections;
      }

      if (_.get(filters, 'filter.dvir', null)) {
        filters.filter.dvirStatus = filters.filter.dvir;
        delete filters.filter.dvir;
      }

      let response;

      const tableStore = new TableStore();

      if (CurrentUserStore.user.role === 'customer') {
        response = await CarStore.getUserCarsForTable(
          filters,
          tableStore,
          CurrentUserStore.user.id,
          CurrentUserStore.user.shopId,
          {
            isAddNextPmSummary: false,
            isAddEngineLightStatus: false,
            isAddDvirData: false,
            isReturnMetaAndData: true,
          }
        );
      } else {
        Logger.log(`load vehicle ${this.shopId}`);
        this.loadShopTags();
        response = await CarStore.getShopCarsForTable(
          filters,
          tableStore,
          this.shopId,
          {
            isAddNextPmSummary: false,
            isAddWorkOrder: true,
            isAddEngineLightStatus: true,
            isAddDvirData: false,
            isReturnMetaAndData: true,
          }
        );
      }

      if (!response) {
        return;
      }

      const setStateParams = {
        contentType: type === 'vehicles' ? 'vehicle' : 'trailer',
        paginationMeta: {
          ...this.state.paginationMeta,
          total: response.meta.count,
          current: filters.offset / 10 + 1,
        },
      };

      await this.getColumns(`${type}-table`);

      const vehicles = response.data.map((car) => ({
        ...car,
        key: car.id,
      }));

      const vehiclesIds = _.map(vehicles, 'id').join(',');

      setStateParams.currentVehicles = vehicles;

      if (this.state.selectAll) {
        setStateParams.selectedAssets = vehicles.map((v) => v.id);
      }

      const hasTags = vehicles.some(
        (vehicle) => Array.isArray(vehicle.tags) && vehicle.tags?.length > 0
      );

      this.setState({ assetsHasTags: hasTags });

      this.setState(setStateParams, () => {
        this.asyncGetDVIR(vehiclesIds);
        this.asyncGetNextPM(vehiclesIds);
        this.asyncGetColumns(vehiclesIds);
        this.showOrHideCustomColumns();

        // if (type === 'vehicles') {
        //   this.asyncGetCarsEngineLightStatus();
        // }
      });
    } catch (error) {
      Logger.error(error);
    } finally {
      Logger.log('finish loading data');
      this.setState({ isLoadingData: false });
    }
  };

  getColumns = async (tableName) => {
    try {
      this.setState({ isLoadingTableColumns: true });
      const settings = await ShopStore.getShopSettings(this.shopId);

      const tables = _.get(settings.result, '[0].settings.table');
      if (tables) {
        const currentTable = _.find(tables, { name: tableName });
        if (currentTable) {
          this.setState((prev) => ({
            ...prev,
            customColumns: currentTable.columns,
          }));
        }
      }
    } catch (e) {
      Logger.log('wrong table');
    } finally {
      this.setState({ isLoadingTableColumns: false });
      Logger.log('finish loaded table');
    }
  };

  setFilter = (key, value) => {
    // force to reset table
    this.setState({
      searchKey: key,
      searchValue: value,
    });
    this.refreshTableOffset = true;
  };

  openShopStatusesModal = (e) => {
    this.stopPropagation(e);

    //FOR CLOSE DROPDDOWN ON OPEN MODAL STATUSES
    const keys = Object.keys(this.state.dropdownVisibility);
    const carId = keys[0];

    if (carId) {
      this.setState((prevState) => ({
        dropdownVisibility: {
          ...prevState.dropdownVisibility,
          [carId]: false,
        },
      }));
    }
    //

    if (this.state.isLoadingStatuses) {
      return;
    }
    this.setState({
      newShopCarStatuses:
        this.state.currentShopStatuses?.length > 0
          ? JSON.parse(JSON.stringify(this.state.currentShopStatuses))
          : CarStatusStore.getDefaultStatusList,
      showShopAssetStatusesModal: true,
    });
  };

  onDownloadVehicleHealthReport = async () => {
    try {
      AppStore.addLoading('Getting Health Report');
      await CarStore.data
        .get(this.state.selectedCarId)
        .downloadVehicleHealthReport(
          this.state.issueReportStatus,
          1000,
          this.state.issueSources
        );
      AppStore.addSuccess('Report downloaded.');
    } catch (err) {
      AppStore.addError(err.message);
    } finally {
      AppStore.removeLoading('Getting report...');
    }
  };

  onPrintVehicleHealthReport = async () => {
    try {
      AppStore.addLoading('Getting Health Report');
      await CarStore.data
        .get(this.state.selectedCarId)
        .printVehicleHealthReport(
          this.state.issueReportStatus,
          1000,
          this.state.issueSources
        );
      AppStore.addSuccess('Report printing.');
    } catch (err) {
      AppStore.addError(err.message);
    } finally {
      AppStore.removeLoading('Getting report...');
    }
  };

  toggleSelectStatusByDefault = (event, key, currentStatusIsDefault) => {
    const checked = !currentStatusIsDefault;
    if (checked) {
      return this.setState({
        newShopCarStatuses: this.state.newShopCarStatuses.map((status) => {
          if (status.key === key) {
            status.is_selected = true;
            status.is_default = true;
          } else {
            status.is_selected = false;
            status.is_default = false;
          }
          return status;
        }),
      });
    }
    return this.setState({
      newShopCarStatuses: this.state.newShopCarStatuses.map((status) => {
        if (status.key === key) {
          status.is_selected = false;
          status.is_default = false;
        }
        return status;
      }),
    });
  };

  toggleStatusRunning = async (event, key, isCurrentChecked) => {
    const checked = !isCurrentChecked;

    this.setState((prevState) => {
      const newStatuses = prevState.newShopCarStatuses.map((status) =>
        status.key === key ? { ...status, is_status_running: checked } : status
      );

      return {
        newShopCarStatuses: newStatuses,
      };
    });
  };

  toggleStatusToShowVendors = async (event, key, isCurrentChecked) => {
    const checked = !isCurrentChecked;

    this.setState((prevState) => {
      const newStatuses = prevState.newShopCarStatuses.map((status) =>
        status.key === key ? { ...status, is_show_vendor: checked } : status
      );

      const showVendorTitle =
        checked || newStatuses.some((status) => status.is_show_vendor);

      return {
        showVendorTitle,
        newShopCarStatuses: newStatuses,
      };
    });
  };

  setQueryToRoutineQueryParams = () => {
    const queryParams = new URLSearchParams(this.props.history.location.search);
    queryParams.set('source', 'routine');
    this.props.history.push({
      search: queryParams.toString(),
    });
  };

  removeQueryToRoutineQueryParams = () => {
    const queryParams = new URLSearchParams(this.props.history.location.search);
    queryParams.delete('source');
    this.props.history.push({
      search: queryParams.toString(),
    });
  };

  clearAllQueryParams = () => {
    const queryParams = new URLSearchParams(this.props.history.location.search);
    queryParams.delete('status');
    queryParams.delete('dvir');
    queryParams.delete('tagNames');
    queryParams.delete('nonTagsSubLocations');
    this.props.history.push({
      search: queryParams.toString(),
    });
  };

  clearSpecificQueryParam = (param) => {
    const queryParams = new URLSearchParams(this.props.history.location.search);
    queryParams.delete(param);
    this.props.history.push({
      search: queryParams.toString(),
    });
  };

  onClearAllFilters = () => {
    this.setState(
      {
        currentFilters: [],
        currentPMFilters: [],
        currentSafetyFilters: [],
        currentEngineLightFilters: [],
        currentDVIRFilters: [],
        selectedAssets: [],
        currentIssuesFilters: [],
        currentSubLocationFilters: [],
        currentNonTagsSubLocationFilters: [],
        filteredInfo: {
          ...this.state.filteredInfo,
          tagNames: [], // Ensure this matches the column's filter key
        },
        trailerSubLocationSearchText: '',
        currentTrailerSafetyFilters: [],
        subLocationFilterDropdownVisible: false,
        trailerSubLocationFilterDropdownVisible: false,
        allRecordsRowOption: false,
        selectAll: false,
      },
      () => {
        // clear all query params
        this.clearAllQueryParams();
        this.onChangeCurrentFilters();
        EventBus.$emit('dashboardWrapper/UPDATE_FILTERS', 'clearSlideout');
      }
    );
  };

  onCloseFilter = (filter) => {
    const type = filter.filterType || 'currentFilters';
    const filterStateMap = {
      currentFilters: 'status',
      currentPMFilters: 'percentage',
      currentSafetyFilters: 'safetyInspections',
      currentEngineLightFilters: 'engineLight',
      currentIssuesFilters: 'issues',
      currentSubLocationFilters: 'tagNames',
      currentNonTagsSubLocationFilters: 'nonTagsSubLocations',
      currentDVIRFilters: 'dvir',
    };
    this.setState(
      {
        [type]: this.state[type].filter(
          (f) =>
            !(
              f.key === filter.key &&
              f.filterType === filter.filterType &&
              f.label === filter.label
            )
        ),
      },
      () => {
        if (this.state[type]?.length === 0) {
          const param = filterStateMap[type];
          if (param) this.clearSpecificQueryParam(param);
        }
        this.onChangeCurrentFilters();
      }
    );
  };

  onAddAsset = async (assetsToAdd) => {
    AppStore.openModals.set('ADD_ASSET_MODAL', false);
    // save the list of trailers using the trailer create endpoint
    if (assetsToAdd?.length) {
      try {
        let firstAssetAddedId = null;
        for (const asset of assetsToAdd) {
          const mileageInKm = calcMileageBack(asset.mileage);
          const engineHoursInSeconds = convertHourToSeconds(asset.engineHours);

          const response = await CarStore.createGenericAsset({
            vin: asset.vin,
            source: 'user',
            assetType: asset.assetType,
            shopId: ShopStore.currentShop.id,
            licensePlate: '',
            mileageInKm: mileageInKm || 0,
            unitId: asset.unitId,
            engineHoursInSecond: engineHoursInSeconds || 0,
            make: asset.make,
            model: asset.model,
            year: asset.year,
            location: asset.location,
            mainDriver: asset.mainDriver,
          });
          if (!firstAssetAddedId) {
            firstAssetAddedId = isArray(response)
              ? response[0].id
              : response.id;
          }
        }
        AppStore.addSuccess('Assets added successfully');
        this.props.loadTotalAssetsCount();
      } catch (error) {
        Logger.log(error);
        AppStore.addError('Error adding assets');
      } finally {
        this.handleSearchData();
      }
    }
  };

  // Attribute for the vehicle table
  vehicleRowSelection = {
    selectedRowKeys: this.state.selectAll
      ? this.state.currentVehicles.map((v) => v.id)
      : this.state.selectedAssets,
    onChange: (selectedRowKeys, selectedRows) => {
      this.setState({
        selectedAssets: selectedRows.map((asset) => asset.id),
      });
    },
    getCheckboxProps: (record) => ({
      // disabled: record.name === 'Disabled User', // Column configuration not to be checked
      // name: record.name,
    }),
    onSelectAll: (selected, selectedRows, changeRows) => {
      this.setState({
        allRecordsRowOption:
          selectedRows?.length < this.state.paginationMeta.total && selected,
        selectAll: false,
      });
    },
  };

  mapIssuesTable = {};

  handleArchiveAssets = async (notes) => {
    try {
      this.setState({ isArchivingAssets: true });
      await CarStore.archiveAssets({
        assetIds: this.state.selectedAssets,
        notes,
        shopId: ShopStore.currentShop.id,
      });
      notification.success({
        message: 'Asset(s) Archived',
        description: 'Assets archived successfully',
        icon: <CheckCircleOutlined style={{ color: 'green' }} />,
      });
      this.setState({ isArchiveAssetsModalVisible: false });
      this.handleSearchData();
      this.props.loadTotalAssetsCount();
    } catch (error) {
      Logger.error(error);
      notification.error({
        message: 'Error',
        description: 'Error archiving asset(s)',
        icon: <CloseCircleOutlined style={{ color: 'red' }} />,
      });
    } finally {
      this.setState({ isArchivingAssets: false });
    }
  };

  // Toggle for Issues
  handleCarIssuesToggle = (record, type) => {
    const {
      expandedCarIds,
      expandedPMCarIds,
      expandedSafetyInspectionIds,
      expandedWorkOrderCarIds,
    } = this.state;

    // Toggle issues expansion
    let newExpandedCarIds = [...expandedCarIds];
    if (newExpandedCarIds.includes(record.id)) {
      newExpandedCarIds = newExpandedCarIds.filter((id) => id !== record.id);
    } else {
      // When expanding issues, collapse PMs, DOT Inspections and Work Orders for this car
      newExpandedCarIds.push(record.id);
      this.setState({
        expandedPMCarIds: expandedPMCarIds.filter((id) => id !== record.id),
        expandedSafetyInspectionIds: expandedSafetyInspectionIds.filter(
          (id) => id !== record.id
        ),
        expandedWorkOrderCarIds: expandedWorkOrderCarIds.filter(
          (id) => id !== record.id
        ),
      });
    }

    if (type === 'pm') {
      const queryParams = new URLSearchParams(
        this.props.history.location.search
      );
      const hasRoutineSource = queryParams.get('source');
      if (!hasRoutineSource) {
        if (this.mapIssuesTable[record.id]) {
          this.mapIssuesTable[record.id].setState({
            source: 'routine',
          });
          this.mapIssuesTable[record.id].allIssuesTableStore.reset();
        }
        this.setQueryToRoutineQueryParams();
      }
    } else {
      const queryParams = new URLSearchParams(
        this.props.history.location.search
      );
      const hasRoutineSource = queryParams.get('source');
      if (hasRoutineSource) {
        if (this.mapIssuesTable[record.id]) {
          this.mapIssuesTable[record.id].setState({
            source: 'all',
          });
          this.mapIssuesTable[record.id].allIssuesTableStore.reset();
        }
        this.removeQueryToRoutineQueryParams();
      }
    }

    this.setState({ expandedCarIds: newExpandedCarIds });
  };

  // Toggle for PMs
  handleCarPMsToggle = (car) => {
    const {
      expandedCarIds,
      expandedPMCarIds,
      expandedSafetyInspectionIds,
      expandedWorkOrderCarIds,
    } = this.state;

    // Toggle PMs expansion
    let newExpandedPMCarIds = [...expandedPMCarIds];
    if (newExpandedPMCarIds.includes(car.id)) {
      newExpandedPMCarIds = newExpandedPMCarIds.filter((id) => id !== car.id);
    } else {
      // When expanding PMs, collapse Issues and DOT Inspections for this car
      newExpandedPMCarIds.push(car.id);
      this.setState({
        expandedCarIds: expandedCarIds.filter((id) => id !== car.id),
        expandedSafetyInspectionIds: expandedSafetyInspectionIds.filter(
          (id) => id !== car.id
        ),
        expandedWorkOrderCarIds: expandedWorkOrderCarIds.filter(
          (id) => id !== car.id
        ),
      });
    }

    this.setState({ expandedPMCarIds: newExpandedPMCarIds });
  };

  // Toggle for DOT Inspections
  handleSafetyInspectionToggle = (car) => {
    const {
      expandedCarIds,
      expandedPMCarIds,
      expandedSafetyInspectionIds,
      expandedWorkOrderCarIds,
    } = this.state;

    // Toggle DOT Inspections expansion
    let newExpandedSafetyInspectionIds = [...expandedSafetyInspectionIds];
    if (newExpandedSafetyInspectionIds.includes(car.id)) {
      newExpandedSafetyInspectionIds = newExpandedSafetyInspectionIds.filter(
        (id) => id !== car.id
      );
    } else {
      // When expanding DOT Inspections, collapse Issues and PMs for this car
      newExpandedSafetyInspectionIds.push(car.id);
      this.setState({
        expandedCarIds: expandedCarIds.filter((id) => id !== car.id),
        expandedPMCarIds: expandedPMCarIds.filter((id) => id !== car.id),
        expandedWorkOrderCarIds: expandedWorkOrderCarIds.filter(
          (id) => id !== car.id
        ),
      });
    }

    this.setState({
      expandedSafetyInspectionIds: newExpandedSafetyInspectionIds,
    });
  };

  /**
   * Toggle for Work Orders
   * @param {number} carId - The ID of the car to toggle
   */
  handleCarWorkOrdersToggle = (carId) => {
    // get all the other expanded car columns
    const {
      expandedCarIds,
      expandedPMCarIds,
      expandedSafetyInspectionIds,
      expandedWorkOrderCarIds,
    } = this.state;

    let newExpandedWorkOrderCarIds = [...expandedWorkOrderCarIds];

    if (newExpandedWorkOrderCarIds.includes(carId)) {
      newExpandedWorkOrderCarIds = newExpandedWorkOrderCarIds.filter(
        (id) => id !== carId
      );
    } else {
      // When expanding work orders, collapse all the other expanded columns for this car
      newExpandedWorkOrderCarIds.push(carId);
      this.setState({
        expandedCarIds: expandedCarIds.filter((id) => id !== carId),
        expandedPMCarIds: expandedPMCarIds.filter((id) => id !== carId),
        expandedSafetyInspectionIds: expandedSafetyInspectionIds.filter(
          (id) => id !== carId
        ),
      });
    }

    this.setState({
      expandedWorkOrderCarIds: newExpandedWorkOrderCarIds,
    });
  };

  convertQueryStringToObject = (queryString) => {
    const params = new URLSearchParams(queryString);
    const shopId = ShopStore.currentShop.id;
    const result = { offset: 0, shopId };

    for (const [key, value] of params.entries()) {
      if (value) {
        // Convert comma-separated values into arrays, or single values as strings
        result[key] = value.includes(',') ? value.split(',') : value;
      }
    }

    if (result.dvirStatus) {
      result.dvirStatus = Array.isArray(result.dvirStatus)
        ? result.dvirStatus
        : [result.dvirStatus];
    }

    if (result.car_status) {
      result.car_status = Array.isArray(result.car_status)
        ? result.car_status
        : [result.car_status];
    }

    if (result.nextPmFilter) {
      result.nextPmFilter = Array.isArray(result.nextPmFilter)
        ? result.nextPmFilter
        : [result.nextPmFilter];
    }

    return result;
  };

  handleExportCSV = async () => {
    if (this.state.selectedAssets?.length === 0) {
      Logger.log('No items selected');
      return;
    }

    const { selectedAssets, currentVehicles, paginationMeta, selectAll } =
      this.state;
    const pageTotal = paginationMeta.total;

    const params = this.convertQueryStringToObject(this.state.vehiclesApiUrl);
    params.limit = pageTotal;
    if (pageTotal > 10) {
      if (selectAll) {
        params.offset = 0;
        try {
          this.setState({ isExportingCSV: true });
          const result = await CarStore.getCarsForCSV(params);
          const csvContent = this.convertToCSV(result.data);
          this.downloadCSV(csvContent);
        } catch (error) {
          Logger.log(error);
        } finally {
          this.setState({ isExportingCSV: false });
        }
      } else {
        Logger.log('Start exporting without calling Api!');
        this.startExportCSVWithoutCallingAPI(currentVehicles, selectedAssets);
      }
    } else {
      Logger.log('Start exporting without calling Api!');
      this.startExportCSVWithoutCallingAPI(currentVehicles, selectedAssets);
    }
  };

  handleExportTrailerCSV = async () => {
    if (this.state.selectedAssets?.length === 0) {
      Logger.log('No trailers selected');
      return;
    }

    Logger.log('exporting trailers...');
    Logger.log('Exporting URL:', this.state.vehiclesApiUrl);

    const { selectedAssets, currentVehicles, paginationMeta, selectAll } =
      this.state;
    const pageTotal = paginationMeta.total;

    const params = this.convertQueryStringToObject(this.state.vehiclesApiUrl);
    params.limit = pageTotal;
    if (pageTotal > 10) {
      if (selectAll) {
        try {
          this.setState({ isExportingCSV: true });
          params.trailers = true;
          const result = await CarStore.getCarsForCSV(params);
          const csvContent = this.convertToTrailerCSV(result.data);
          this.downloadCSV(csvContent);
        } catch (error) {
          Logger.log(error);
        } finally {
          this.setState({ isExportingCSV: false });
        }
      } else {
        Logger.log('Start exporting selected trailers without calling API!');
        this.startExportCSVWithoutCallingAPITrailers(
          currentVehicles,
          selectedAssets,
          this.convertTrailerToCSV
        );
      }
    } else {
      Logger.log('Start exporting selected trailers without calling API!');
      this.startExportCSVWithoutCallingAPITrailers(
        currentVehicles,
        selectedAssets,
        this.convertTrailerToCSV
      );
    }
  };

  startExportCSVWithoutCallingAPITrailers = (
    currentVehicles,
    selectedAssets
  ) => {
    const selectedData = currentVehicles.filter((car) =>
      selectedAssets.includes(car.id)
    );

    const csvContent = this.convertToTrailerCSV(selectedData);

    this.downloadCSV(csvContent);
  };

  startExportCSVWithoutCallingAPI = (currentVehicles, selectedAssets) => {
    const selectedData = currentVehicles.filter((car) =>
      selectedAssets.includes(car.id)
    );

    const csvContent = this.convertToCSV(selectedData);

    this.downloadCSV(csvContent);
  };

  convertToTrailerCSV = (data) => {
    const isTimHortonsFleet = customFleets.timhortons.includes(
      ShopStore.currentShop.parentShopId || ShopStore.currentShop.id
    );

    const gotTags = data.some((car) => car.tags && car.tags.length > 0);

    let subLocations = [];
    const gotSublocs =
      data.some((car) => car.meta?.assetLocationId) && !gotTags;
    if (gotSublocs) {
      subLocations = (
        ShopStore.shopSettings?.result?.[0]?.settings?.locations || []
      ).map((subLocation) => ({
        [subLocation.id]: `${subLocation.code || ''} - ${subLocation.description || ''}`,
      }));
    }

    const subLocTagHeaders = isTimHortonsFleet
      ? ['Resident Yard']
      : ['Sub-location'];

    const headers = [
      'Trailer Name',
      'Vin',
      ...(gotTags || gotSublocs ? subLocTagHeaders : []),
      'DVIR Status',
      'DOT Inspection',
      'Trailer Status, Notes',
    ];

    let gotSublocations = false;
    // Determine whether to use kilometers or miles
    const userSettings =
      CurrentUserStore.user?.settings?.odometer === 'km' ? 'km' : 'miles';

    const rows = data.map((car) => {
      let carName = car.carName || '--';
      carName = `${carName}`;
      let carVin = car.vin || '--';
      const notes = car.notes ? `"${car.notes.replace(/"/g, '""')}"` : '--';

      // Handle DVIR status
      let safetyStatus =
        car.dvir && car.dvir.record
          ? car.dvir.record.safetyStatus || 'Unknown'
          : '--';
      const totalDefects =
        car.dvir && car.dvir.record?.payload?.trailerDefects
          ? car.dvir.record.payload.trailerDefects?.length
          : 0;

      if (totalDefects > 0) {
        safetyStatus = `${safetyStatus} | Defects: ${totalDefects}`;
      }

      // Handle Next PM
      const {
        due_engine_hours,
        due_mileage,
        due_time_in_s,
        rule_type,
        pm_percent,
        pm_status,
      } = car;
      let nextPM = '--'; // Default value when no PM data is available

      if (pm_percent !== null && pm_percent !== undefined) {
        let displayValue;
        let displayText;

        if (rule_type === 'time') {
          // Calculate time remaining in days or months
          const now = new Date();
          const dueAt = moment.unix(due_time_in_s);
          const diffInDays = dueAt.diff(now, 'days');
          const diffInMonths = Math.ceil(diffInDays / 30.4375);

          if (diffInMonths < 1) {
            displayValue = Math.abs(diffInDays);
            displayText = 'day(s)';
          } else {
            displayValue = Math.abs(diffInMonths);
            displayText = 'month(s)';
          }
        } else {
          // Calculate remaining mileage or engine hours
          const hoursRemainingValue =
            rule_type === 'engine_hours'
              ? Math.ceil(
                  Math.abs(
                    (Number(due_engine_hours) - Number(car.engineHours)) / 3600
                  )
                )
              : undefined;

          const kmRemaining =
            rule_type === 'mileage'
              ? Math.ceil(
                  Math.abs(Number(due_mileage) - Number(car.totalMileage))
                )
              : undefined;

          const milesRemaining = kmRemaining
            ? Math.ceil(kmRemaining / 1.60934)
            : undefined;
          const milesOrKm =
            userSettings === 'km' ? kmRemaining : milesRemaining;
          const milesOrKmText = userSettings === 'km' ? 'km' : 'miles';

          displayText =
            milesOrKm !== undefined ? milesOrKmText : 'engine hours';
          displayValue =
            milesOrKm !== undefined ? milesOrKm : hoursRemainingValue;
        }

        nextPM = `${pm_percent}% (${pm_status} by ${displayValue} ${displayText})`;
      }

      // DOT Inspection
      let dotInspection = '--';
      const {
        safety_due_time_in_s,
        safety_pm_percent,
        safety_pm_status,
        safety_rule_type,
      } = car;

      if (safety_pm_percent != null) {
        const dueMoment = moment.unix(safety_due_time_in_s);
        const dueInDays = dueMoment.diff(moment(), 'days');
        const overdueDays = moment().diff(dueMoment, 'days');

        const overdueOrDueIn = safety_due_time_in_s
          ? overdueDays > 0
            ? overdueDays
            : dueInDays
          : null;
        const dueDate =
          safety_rule_type === 'time' ? dueMoment.format('MM/DD/YYYY') : '';

        const description = `${
          safety_pm_status === 'In Compliance' ? 'Due' : safety_pm_status
        } ${dueDate}`;
        const status =
          safety_pm_status === 'In Compliance'
            ? safety_pm_status
            : overdueOrDueIn != null
              ? overdueOrDueIn > 0
                ? `in ${overdueOrDueIn} day(s)`
                : `by ${Math.abs(overdueOrDueIn)} day(s)`
              : '';
        dotInspection = `${safety_pm_percent}% (${description} ${status})`;
      }

      // Handle Car Status
      const carStatus = this.getCarStatus(car.carStatus) || 'Running';

      // tags
      let tags = car.tags ? car.tags[0].name : null;

      //if sublocations
      if (gotSublocs) {
        const subLocation = subLocations.find(
          (subLocation) => subLocation[car.meta?.assetLocationId]
        );
        if (subLocation) {
          tags = subLocation[car.meta.assetLocationId];
        }
      }

      return [
        carName,
        carVin,
        ...(gotTags || gotSublocs ? [tags || '-'] : []),
        safetyStatus,
        dotInspection,
        carStatus,
        notes,
      ];
    });

    const csvArray = [headers, ...rows];
    return csvArray.map((e) => e.join(',')).join('\n');
  };

  convertToCSV = (data) => {
    const isTimHortonsFleet = customFleets.timhortons.includes(
      ShopStore.currentShop.parentShopId || ShopStore.currentShop.id
    );

    const gotTags = data.some((car) => car.tags && car.tags.length > 0);

    let subLocations = [];
    const gotSublocs =
      data.some((car) => car.meta?.assetLocationId) && !gotTags;
    if (gotSublocs) {
      subLocations = (
        ShopStore.shopSettings?.result?.[0]?.settings?.locations || []
      ).map((subLocation) => ({
        [subLocation.id]: `${subLocation.code || ''} - ${subLocation.description || ''}`,
      }));
    }

    const subLocTagHeaders = isTimHortonsFleet
      ? ['Resident Yard']
      : ['Sub-location'];

    let headers = [
      'Car Name',
      'Vin',
      'Telematic Device',
      ...(gotTags || gotSublocs ? subLocTagHeaders : []),
      'Mileage',
      'Engine Hours',
      'DVIR Status',
      'Engine Light Status',
      'Issues',
      'Next PM',
      'DOT inspection',
      'Car Status, Notes',
    ];

    // Determine whether to use kilometers or miles
    const userSettings =
      CurrentUserStore.user?.settings?.odometer === 'km' ? 'km' : 'miles';

    const rows = data.map((car) => {
      const totalKmMi =
        userSettings === 'km'
          ? `${Math.round(Number(car.totalMileage))} km`
          : `${(Number(car.totalMileage) * 0.621371).toFixed(2)} mi`;

      const engineHours = Math.round(car.engineHours / 3600);
      const notes = car.notes ? `"${car.notes.replace(/"/g, '""')}"` : '--';
      let carName = car.carName || '--';
      let carVin = car.vin || '--';

      const device = car.scanner?.scannerId;
      let deviceManufacturer = device
        ? device.substring(0, device.indexOf(':'))
        : '--';
      let deviceId = device ? device.substring(device.indexOf(':') + 1) : '--';
      const carDevice = `${deviceManufacturer} - ${deviceId}`;

      // Handle DVIR status
      let safetyStatus =
        car.dvir && car.dvir.record
          ? car.dvir.record.safetyStatus || 'Unknown'
          : '--';
      const totalDefects =
        car.dvir && car.dvir.record?.payload?.trailerDefects
          ? car.dvir.record.payload.trailerDefects.length
          : 0;

      if (totalDefects > 0) {
        safetyStatus = `${safetyStatus} | Defects: ${totalDefects}`;
      }

      // Handle Engine Light Status
      const engineLightStatus = car.currentEngineLightStatus?.payload
        ? [
            car.currentEngineLightStatus.payload.faultState === 'active'
              ? 'Active'
              : 'Inactive',
            car.currentEngineLightStatus.payload.redStopLamp
              ? 'Red Stop Lamp: On'
              : '',
            car.currentEngineLightStatus.payload.malfunctionLamp
              ? 'Malfunction Lamp: On'
              : '',
            car.currentEngineLightStatus.payload.amberWarningLamp
              ? 'Amber Warning Lamp: On'
              : '',
            car.currentEngineLightStatus.payload.protectWarningLamp
              ? 'Protect Warning Lamp: On'
              : '',
            car.currentEngineLightStatus.payload.generalVehicleWarningLight
              ? 'General Warning: On'
              : '',
          ]
            .filter((status) => status !== '')
            .join('; ')
        : '--';

      // Handle Issues
      const issueCounts = car.issueCounts
        ? `Critical: ${car.issueCounts.critical || 0} | Major: ${
            car.issueCounts.major || 0
          } | Minor: ${car.issueCounts.minor || 0}`
        : 'No Issues';

      // Handle Next PM
      let nextPM = '--';
      const {
        due_engine_hours,
        due_mileage,
        due_time_in_s,
        rule_type,
        pm_percent,
        pm_status,
      } = car;

      if (pm_percent !== null && pm_percent !== undefined) {
        const odometer =
          CurrentUserStore.user?.settings?.odometer === 'km' ? 'km' : 'miles';

        const carRemains = remains({
          dueTime: car.due_time_in_s,
          safetyInspection: false,
          ruleType: car.rule_type,
          dueEngineHours: car.due_engine_hours,
          engineHours: car.engineHours,
          dueMileage: car.due_mileage,
          totalMileage: car.totalMileage,
          odometer: car.odometer,
          displayType: car.display_type,
        });

        const dueDate =
          car.display_type.display === 'time'
            ? moment(new Date(car.due_time_in_s * 1000)).format('MM/DD/YYYY')
            : '';

        nextPM = `${pm_percent}% (${pm_status} ${dueDate} ${
          pm_status === 'Overdue' ? 'by' : 'in'
        } ${carRemains[0].displayValue} ${carRemains[0].displayText})`;
      }

      // DOT Inspection
      let dotInspection = '--';
      const {
        safety_due_time_in_s,
        safety_pm_percent,
        safety_pm_status,
        safety_rule_type,
      } = car;

      if (safety_pm_percent != null) {
        const dueMoment = moment.unix(safety_due_time_in_s);
        const dueInDays = dueMoment.diff(moment(), 'days');
        const overdueDays = moment().diff(dueMoment, 'days');

        const overdueOrDueIn = safety_due_time_in_s
          ? overdueDays > 0
            ? overdueDays
            : dueInDays
          : null;

        const dueDate =
          safety_rule_type === 'time' ? dueMoment.format('MM/DD/YYYY') : '';

        const description = `${
          safety_pm_status === 'In Compliance' ? 'Due' : safety_pm_status
        } ${dueDate}`;
        const status =
          safety_pm_status === 'In Compliance'
            ? safety_pm_status
            : overdueOrDueIn != null
              ? overdueOrDueIn > 0
                ? `in ${overdueOrDueIn} day(s)`
                : `by ${Math.abs(overdueOrDueIn)} day(s)`
              : '';

        dotInspection = `${safety_pm_percent}% (${description} ${status})`;
      }

      // Handle Car Status
      const carStatus = this.getCarStatus(car.carStatus) || 'Running';

      // tags
      let tags = car.tags ? car.tags[0].name : null;

      //if sublocations
      if (gotSublocs) {
        const subLocation = subLocations.find(
          (subLocation) => subLocation[car.meta?.assetLocationId]
        );
        if (subLocation) {
          tags = subLocation[car.meta.assetLocationId];
        }
      }

      return [
        carName,
        carVin,
        carDevice,
        ...(gotTags || gotSublocs ? [tags || '-'] : []),
        totalKmMi,
        `${engineHours} engine hours`,
        safetyStatus,
        engineLightStatus,
        issueCounts,
        nextPM,
        dotInspection,
        carStatus,
        notes,
      ];
    });

    const csvArray = [headers, ...rows];

    return csvArray.map((e) => e.join(',')).join('\n');
  };

  getCarStatus = (carStatus) => {
    for (const item of this.state.currentShopStatuses) {
      if (item.key === carStatus) {
        return item.description;
      }
    }
    return undefined;
  };

  downloadCSV = (csvContent) => {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');

    const now = new Date();
    const timestamp = now.toISOString().replace(/[-:T]/g, '').split('.')[0];

    const filename = `exported_vehicles_data_${timestamp}.csv`;

    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
  };

  handleFormSubmit = (values) => {
    let total = 0;

    if (values.car_status) {
      total += values.car_status?.length;
    }

    if (values.dvirStatus) {
      total += values.dvirStatus?.length;
    }

    if (values.nextPmFilter) {
      total += values.nextPmFilter?.length;
    }

    this.setState({ popoverVisible: false });
    this.setState({ countFiltersSelected: total });
  };

  handleChangeFormFilter = (key, value) => {
    let filters = {};
    if (key === 'car_status') {
      filters = { ...filters, ...{ car_status: value } };
    }

    if (key === 'dvirStatus') {
      filters = { ...filters, ...{ dvirStatus: value } };
    }

    if (key === 'nextPmFilter') {
      filters = { ...filters, ...{ nextPmFilter: value } };
    }

    this.loadData(this.props.type, filters);
  };

  togglePopoverVisibility = (visible) => {
    this.setState({ popoverVisible: visible });
  };

  toggleDropdown = (carId, visible) => {
    this.setState((prevState) => ({
      dropdownVisibility: {
        ...prevState.dropdownVisibility,
        [carId]: visible, // Atualiza a visibilidade apenas do carro específico
      },
    }));
  };

  handlerResetCustomColumnTable = async (data) => {
    try {
      AppStore.addLoading('Setting Table Columns');
      const settings = await ShopStore.getShopSettings(this.shopId);

      if (!_.get(settings, 'result[0].settings.table')) {
        _.set(settings, 'result[0].settings.table', []);
      }

      const tables = _.get(settings.result, '[0].settings.table', []);

      const currentTableIndex = _.findIndex(tables, { name: data.name });

      if (currentTableIndex !== -1) {
        tables.splice(currentTableIndex, 1);
      } else {
        tables.push({ name: data.name, columns: [] });
      }

      _.set(settings, 'result[0].settings.table', tables);

      await ShopStore.upsertShopSettings(
        this.shopId,
        settings.result[0].settings
      );

      this.setState({ customColumns: [] });

      AppStore.addSuccess('Saved successfully!');
    } finally {
      AppStore.removeLoading('');
    }
  };

  handlerCustomColumnTable = async (data) => {
    try {
      runInAction(() => AppStore.addLoading('Setting Table Columns'));
      const settings = await ShopStore.getShopSettings(this.shopId);

      const tables = _.get(settings.result, '[0].settings.table', []);

      const currentTable = _.find(tables, { name: data.name });

      if (currentTable) {
        currentTable.columns = data.columns;
      } else {
        tables.push(data);
      }

      _.set(settings.result, '[0].settings.table', tables);

      runInAction(
        async () =>
          await ShopStore.upsertShopSettings(
            this.shopId,
            settings.result[0].settings
          )
      );

      this.setState({
        customColumns: data.columns,
      });

      runInAction(() => AppStore.addSuccess('Saved successfully!'));
    } catch (e) {
      Logger.log(`error setting custom column table, ${e}`);
    } finally {
      runInAction(() => AppStore.removeLoading(''));
    }
  };

  selectAll = () => {
    this.setState({
      selectAll: true,
    });
  };

  clearSelection = () => {
    this.setState({
      selectAll: false,
      allRecordsRowOption: false,
      selectedAssets: [],
    });
  };

  handleVendorUpdateForStatusDropDown = (carId, vendorId) => {
    this.setState((prevState) => ({
      currentVehicles: prevState.currentVehicles.map((car) =>
        car.id === carId ? { ...car, carVendorId: vendorId } : car
      ),
    }));
  };

  createColumn = async (key, title) => {
    await ShopStore.updateColumn(this.shopId, {
      key: key,
      title: title,
      created_at: new Date(),
    });
  };

  updateTitle = async (missingKey, newTitle) => {
    const oldKey = this.slugify(missingKey);
    const newKey = this.slugify(newTitle);

    if (oldKey === newKey) {
      return;
    }

    const updatedColumns = this.state.customColumns.map((col) =>
      col === missingKey ? newKey : col
    );

    const updatedShopsColumns = {
      ...this.state.shopsColumns,
      [newKey]: newTitle,
    };
    delete updatedShopsColumns[oldKey];

    const updatedVehicles = this.state.currentVehicles.map((vehicle) => {
      if (Object.prototype.hasOwnProperty.call(vehicle, oldKey)) {
        return {
          ...vehicle,
          [newKey]: vehicle[oldKey],
        };
      }
      return vehicle;
    });

    this.setState({
      customColumns: updatedColumns,
      shopsColumns: updatedShopsColumns,
      currentVehicles: updatedVehicles,
    });

    const data = {
      old_key: oldKey,
      key: newKey,
      title: newTitle,
      created_at: new Date(),
    };

    await ShopStore.updateColumn(this.shopId, data);
  };

  updateColumn = async (car, columnKey, value) => {
    const carId = car.id;
    const shopId = this.shopId;

    const data = {
      car_id: carId,
      value: value,
    };

    await ShopStore.updateColumnValue(shopId, columnKey, data);
  };

  deleteColumn = (columnKey) => {
    const shopId = this.shopId;
    ShopStore.deleteColumn(shopId, columnKey);

    const newCustomColumns = this.state.customColumns.filter(
      (key) => key !== columnKey
    );

    const { [columnKey]: removed, ...newShopsColumns } =
      this.state.shopsColumns;

    this.setState({
      customColumns: newCustomColumns,
      shopsColumns: newShopsColumns,
    });
  };

  slugify(str) {
    return str
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/--+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  render() {
    const vehicleRowSelectionNew = {
      selectedRowKeys: this.state.selectAll
        ? this.state.currentVehicles.map((v) => v.id)
        : this.state.selectedAssets,
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({
          selectedAssets: selectedRows.map((asset) => asset.id),
        });
        if (selectedRows?.length < 10) {
          this.setState({
            selectAll: false,
            allRecordsRowOption: false,
          });
        } else {
          this.setState({
            allRecordsRowOption: true,
          });
        }
      },
      onSelectAll: (selected, selectedRows) => {
        this.setState({
          allRecordsRowOption:
            selectedRows?.length < this.state.paginationMeta.total && selected,
          selectAll: false,
        });
      },
    };

    const { device, orientation } = DeviceStore;
    let newColumns;

    const currStep = IssueStore.currentPMFeedbacks.currentStep;

    const statusOptions = [
      { label: 'New', value: 'new' },
      { label: 'Waiting For Invoice', value: 'waitingForApproval' },
      { label: 'Done', value: 'done' },
    ];

    const sourceOptions = [
      { label: 'Engine Codes', value: 'dtc' },
      { label: 'Routine/OEM Recommended Services', value: 'routine' },
      { label: 'Recall', value: 'recall' },
      { label: 'Fleet Manager/Driver Reported', value: 'user' },
      { label: 'Pitstop Algorithm Generated Services', value: 'algorithm' },
      { label: 'Service Records', value: 'archive' },
      { label: 'Light Vehicle DTCs', value: 'lightVehicleDTC' },
      { label: 'Heavy Vehicle DTCs', value: 'heavyVehicleDTC' },
    ];

    this.backupColumns =
      this.props.type === 'vehicles'
        ? this.vehicleColumns
        : this.props.type === 'trailers'
          ? this.trailerColumns
          : [];

    if (this.state.customColumns?.length > 0) {
      newColumns = [
        ...this.backupColumns.filter((col) =>
          this.state.customColumns.includes(col.key)
        ),
      ];
    } else if (device === 'tablet' && orientation === 'portrait') {
      const allowedTabletColumn = [
        // 'indicator',
        'car_name',
        'engine_light',
        'issues',
        'dvir',
        'actions',
      ];
      const renameColumn = [
        {
          key: 'car_name',
          title: 'Unit Id',
        },
        {
          key: 'engine_light',
          title: 'Engine Light',
        },
        {
          key: 'dvir',
          title: 'DIVR',
        },
      ];
      newColumns = this.vehicleColumns
        .filter((c) => allowedTabletColumn.includes(c.key))
        .map((col) => {
          const renamedColumn = renameColumn.find((rn) => rn.key === col.key);
          if (renamedColumn) {
            return {
              ...col,
              title: renamedColumn.title,
            };
          }

          return col;
        });
    } else {
      newColumns = this.backupColumns;
    }

    if (Object.keys(this.state.shopsColumns).length > 0) {
      const keys = Object.keys(this.state.shopsColumns);
      newColumns = [
        ...newColumns,
        ...keys.map((key) => ({
          key: key,
          title: (
            <EditableColumnTitle
              title={this.state.shopsColumns[key]}
              onSave={(newTitle) => {
                this.updateTitle(key, newTitle);
              }}
              onDelete={() => {
                this.deleteColumn(key);
              }}
            />
          ),
          field: key,
          align: 'center',
          sorter: false,
          width: 200,
          render: (car) => {
            return (
              <TextArea
                style={{ height: '100px' }}
                defaultValue={car[key]}
                onBlur={(e) => {
                  e.preventDefault();
                  this.updateColumn(car, key, e.target.value);
                }}
              />
            );
          },
        })),

        // }))
      ];
    }

    const isTimHortonsFleet = customFleets.timhortons.includes(
      ShopStore.currentShop.parentShopId || ShopStore.currentShop.id
    );

    const headerTable = () => {
      const { device, orientation } = DeviceStore;
      return (
        <>
          {device === 'mobile' && (
            <Row style={{ marginBottom: 24 }}>
              <Col span={24}>
                <>
                  <AppAlert
                    message={
                      <>
                        <Text strong>
                          Some elements are now shown in portrait view
                        </Text>
                        <br />
                        <Text>
                          To view all columns and reports, use the device in
                          landscape
                        </Text>
                      </>
                    }
                  />
                </>
              </Col>
            </Row>
          )}
          <Row
            type="flex"
            justify={device === 'mobile' ? 'space-between' : 'start'}
            style={{ marginBottom: 10 }}
          >
            {device === 'mobile' && (
              <Col span={9}>
                <FormFilter
                  type={this.props.type}
                  filterOptions={this.filterOptions}
                  dvirFilterOptions={dvirFilterOptions()}
                  nextPMFilterOptions={nextPMFilterOptions()}
                  onSubmit={this.handleFormSubmit}
                  onChangeFilter={this.handleChangeFormFilter}
                  onClear={this.onClearAllFilters}
                  popoverVisible={this.state.popoverVisible}
                  togglePopoverVisibility={this.togglePopoverVisibility}
                  countFiltersSelected={this.state.countFiltersSelected}
                />
              </Col>
            )}
            <Col span={device === 'mobile' ? 14 : 18}>
              <Row gutter={[16, 16]} style={{ marginTop: '1rem' }}>
                <Col
                  span={
                    this.props.type !== 'vehicles' && device !== 'mobile'
                      ? 14
                      : 14
                  }
                >
                  <DebounceSearch
                    placeholder={'Search by Unit ID, VIN or License Plate #'}
                    onSearch={(value) => {
                      this.setState({
                        searchValue: value,
                        searchKey: 'carNameOrVinOrLicense',
                      });
                    }}
                    initialValue={this.state.searchValue}
                    timeout={500}
                  />
                </Col>
                {/* this.props.type !== 'vehicles' &&  */}
                {device !== 'mobile' ? (
                  <Col span={32}>
                    <Button
                      style={{ marginLeft: '1rem' }}
                      onClick={() => {
                        // open modal to add trailer
                        AppStore.openModals.set('ADD_ASSET_MODAL', true);
                      }}
                    >
                      <PlusOutlined />
                      Add Asset
                    </Button>
                    <Button
                      style={{ marginLeft: '1rem' }}
                      type="primary"
                      onClick={() => {
                        const hasTags =
                          this.state.assetsHasTags ||
                          customFleets.ufpFleet.includes(
                            ShopStore.currentShop.parentShopId ||
                              ShopStore.currentShop.id
                          );
                        let tagSubLocs = [];
                        if (hasTags) {
                          const shopId = ShopStore.currentShop.id;

                          const allOptions =
                            this.subLocationsFilterOptions(shopId);

                          tagSubLocs = allOptions.filter((option) =>
                            option.text
                              .toLowerCase()
                              .includes(
                                this.state.subLocationSearchText?.toLowerCase() ||
                                  ''
                              )
                          );
                        }
                        EventBus.$emit('dashboardWrapper/OPEN_SLIDE_OUT', {
                          type: 'filter',
                          data: {
                            filterOptions: {
                              status: this.filterOptions,
                              pm: nextPMFilterOptions(),
                              safety: safetyInspectionsFilterOptions(),
                              dvir: dvirFilterOptions(),
                              light: engineLightFilterOptions(),
                              issues: issuesFilterOptions(),
                              location:
                                ShopStore.shopSettings?.result[0]?.settings
                                  ?.locations || [],
                              tagLocation: tagSubLocs || [],
                            },
                            selectedFilters: this.combinedCurrentFilters,
                            hasTags: hasTags,
                          },
                          title: 'Filter Assets Table',
                        });
                      }}
                    >
                      {this.combinedCurrentFilters?.length === 0 ? (
                        <FilterOutlined />
                      ) : (
                        <FilterFilled />
                      )}
                      Filters
                      {
                        <FilterCountBadge>
                          {this.combinedCurrentFilters?.length}
                        </FilterCountBadge>
                      }
                    </Button>
                  </Col>
                ) : (
                  <></>
                )}
              </Row>
            </Col>
          </Row>

          <Row
            type="flex"
            style={{ marginBottom: 10 }}
            gutter={[16, 16]}
            justify="space-between"
          >
            <Col>
              {!CurrentUserStore.isTechnician && (
                <Button
                  type="primary"
                  size="small"
                  disabled={this.state.selectedAssets?.length === 0}
                  style={{ marginRight: 10 }}
                  onClick={() => {
                    this.setState({
                      isArchiveAssetsModalVisible: true,
                      archivingAssetType: this.props.type,
                    });
                  }}
                  data-test="archive-vehicles-button"
                >
                  Archive Assets
                </Button>
              )}

              <Button
                type="primary"
                size="small"
                disabled={this.state.selectedAssets?.length === 0}
                style={{ marginRight: 10 }}
                onClick={
                  this.props.type === 'vehicles'
                    ? this.handleExportCSV
                    : this.handleExportTrailerCSV
                }
                data-test="export-csv-button"
              >
                Export CSV
              </Button>

              <Button
                type="primary"
                size="small"
                disabled={this.state.selectedAssets?.length === 0}
                style={{ marginRight: 10 }}
                onClick={() =>
                  this.showSubLocationModal(this.state.selectedAssets)
                }
                data-test="export-csv-button"
              >
                {isTimHortonsFleet
                  ? 'Change Resident Yard'
                  : 'Change Sub-location'}
              </Button>

              <Modal
                title="Exporting CSV..."
                open={this.state.isExportingCSV}
                footer={null}
                closable={false}
                centered
              >
                <div style={{ textAlign: 'center' }}>
                  <Spin size="large" />
                  <p>Processing your CSV export. Please wait...</p>
                </div>
              </Modal>

              {this.combinedCurrentFilters?.length === 0 ? (
                <Button disabled size="small" style={{ marginRight: 10 }}>
                  No filters selected
                </Button>
              ) : (
                <Button
                  size="small"
                  type="primary"
                  style={{ marginRight: 10 }}
                  onClick={() => this.onClearAllFilters()}
                >
                  Clear all filters
                </Button>
              )}
              {/* Add badges with current selected filters here */}
              {this.combinedCurrentFilters.map((filter, index) => {
                const uniqueKey = `${filter.filterType || 'general'}-${filter.key || filter.value}-${index}`;
                return (
                  <Tag
                    key={uniqueKey}
                    className="filter-tag"
                    closable
                    onClose={() => this.onCloseFilter(filter)}
                  >
                    {filter.label}
                  </Tag>
                );
              })}
            </Col>
            <Col>
              <Row>
                <Button
                  variant="outlined"
                  style={{ marginRight: 10 }}
                  onClick={() => {
                    const existing = Object.keys(this.state.shopsColumns);
                    let base = 'New Column';
                    let suffix = 0;
                    let newName = base;

                    while (existing.includes(this.slugify(newName))) {
                      suffix++;
                      newName = `${base}-${suffix}`;
                    }

                    const slugKey = this.slugify(newName);

                    this.setState({
                      shopsColumns: {
                        ...this.state.shopsColumns,
                        [slugKey]: newName,
                      },
                    });

                    this.createColumn(slugKey, newName);

                    setTimeout(() => {
                      const tableBody =
                        this.vehicleTableRef.current?.querySelector(
                          '.ant-table-body'
                        );
                      if (tableBody) {
                        tableBody.scrollLeft = tableBody.scrollWidth;
                      }
                    }, 500);
                  }}
                >
                  <PlusOutlined />
                  Add column
                </Button>
                <CustomTableColumn
                  title={'Customize column assets'}
                  shopId={this.shopId}
                  fixedColumns={
                    this.props.type === 'vehicles'
                      ? ['car_name']
                      : ['car_name', 'actions']
                  }
                  key={`custom-table-${this.props.type}-${new Date()}`}
                  tableName={`${this.props.type}-table`}
                  columns={
                    this.props.type === 'vehicles'
                      ? this.vehicleColumns
                      : this.trailerColumns
                  }
                  defaultColumns={this.state.customColumns}
                  onSubmit={this.handlerCustomColumnTable}
                  onReset={this.handlerResetCustomColumnTable}
                />
              </Row>
              <ScrollIndicator>
                Scroll horizontally to see more
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 18L15 12L9 6"
                    stroke="#8c8c8c"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </ScrollIndicator>
            </Col>
          </Row>
        </>
      );
    };

    // console.log('!!! this.state.currentVehicles: ', this.state.currentVehicles);

    return (
      <IndicatorTableWrapper>
        {headerTable()}

        {device === 'mobile' ? (
          <>
            <List
              dataSource={this.state.currentVehicles}
              loading={this.state.isLoadingData}
              pagination={{
                ...this.state.paginationMeta,
                onChange: (page, pageSize) =>
                  this.handleCardsChange({ page: page, pageSize: pageSize }),
              }}
              renderItem={(item) => {
                const isExpanded = this.state.expandedCards[item.id];
                if (this.props.type === 'vehicles') {
                  return (
                    <CardVehicle
                      key={item.id}
                      car={item}
                      isExpanded={isExpanded}
                      dropdown={() => (
                        <StatusDropdown
                          car={item}
                          currentShopStatuses={this.state.currentShopStatuses}
                          currentShopVendors={this.state.currentShopVendors}
                          dropdownVisibility={this.state.dropdownVisibility}
                          carStatusStore={CarStatusStore}
                          onVendorUpdate={
                            this.handleVendorUpdateForStatusDropDown
                          }
                          onEditStatusClick={this.openShopStatusesModal}
                          onDropdownOpenChange={this.toggleDropdown}
                          onClickNewStatus={this.onClickNewStatus}
                        />
                      )}
                      toggleCard={this.toggleCardExpansion}
                      saveNotes={this.saveCarNotes}
                      nextPm={renderNextPMDueInPercentage(
                        item,
                        this.handleCarIssuesToggle,
                        this.state.expandedCarIds
                      )}
                      actions={
                        <Row
                          type="flex"
                          justify="space-between"
                          align="middle"
                          gutter={[16, 0]}
                        >
                          <Col span={12}>
                            <Button
                              type="primary"
                              ghost
                              block
                              onClick={() =>
                                this.setState(
                                  { selectedCarId: item.id },
                                  () => {
                                    AppStore.openModals.set(
                                      'SHARE_VEHICLE_HEALTH_REPORT_MODAL',
                                      true
                                    );
                                  }
                                )
                              }
                            >
                              Share Report
                            </Button>
                          </Col>

                          <Col span={12}>
                            <Button
                              type="primary"
                              block
                              onClick={() =>
                                this.setState(
                                  { selectedCarId: item.id },
                                  () => {
                                    this.setState(
                                      {
                                        isPrintHealthReport: false,
                                      },
                                      () => {
                                        this.onDownloadVehicleHealthReport();
                                      }
                                    );
                                  }
                                )
                              }
                            >
                              Download Report
                            </Button>
                          </Col>
                        </Row>
                      }
                    />
                  );
                } else {
                  return (
                    <CardTrailer
                      key={item.id}
                      trailer={item}
                      isExpanded={isExpanded}
                      toggleCard={this.toggleCardExpansion}
                      nextPm={renderNextPMDueInPercentage(
                        item,
                        this.handleCarIssuesToggle,
                        this.state.expandedCarIds
                      )}
                    />
                  );
                }
              }}
            />
          </>
        ) : (
          <div
            style={{ overflow: 'auto', width: '100%' }}
            ref={this.vehicleTableRef}
          >
            <PMFeedbackModal
              id="pm-feedback-modal"
              title={IssueStore.currentPMFeedbacks.title}
              currentStep={currStep}
              pmsToReceiveFeedback={
                IssueStore.currentPMFeedbacks.pmsToReceiveFeedback
              }
              isModalVisible={IssueStore.currentPMFeedbacks.isModalVisible}
              onSave={() => {
                if (this.pmTableRef && this.pmTableRef.current) {
                  this.handleOnChangeCurrentFiltersDebouncer();
                  this.pmTableRef.current.fetchData(1, 8, {}, []);
                }
              }}
            />
            <TableContainer
              rowSelection={vehicleRowSelectionNew}
              columns={newColumns}
              dataSource={this.state.currentVehicles}
              loading={
                this.state.isLoadingData ||
                this.state.isLoadingInitial ||
                this.state.isLoadingTableColumns
              }
              pagination={{
                ...this.state.paginationMeta,
                onChange: () => {
                  if (this.state.selectAll) {
                    this.setState({
                      selectedAssets: this.state.currentVehicles.map(
                        (v) => v.id
                      ),
                    });
                  } else {
                    this.setState({
                      selectedAssets: [],
                      allRecordsRowOption: false,
                      selectAll: false,
                    });
                  }
                },
              }}
              onChange={this.handleTableChange}
              rowClassName={(record) => {
                return record.id === this.state.highlightedCarId
                  ? 'highlighted-car-row'
                  : '';
              }}
              tableLayout="fixed"
              expandedRowRender={(car) => {
                // Check if the current car ID is in the expanded PM car list
                const isPMExpanded = this.state.expandedPMCarIds.includes(
                  car.id
                );
                const isSafetyExpanded =
                  this.state.expandedSafetyInspectionIds.includes(car.id);
                const isWorkOrderExpanded =
                  this.state.expandedWorkOrderCarIds.includes(car.id);
                // Render the PM-related view when PMs are expanded
                if (isPMExpanded) {
                  return (
                    <div>
                      <div className="pm-table-wrapper">
                        <PMTable
                          carId={car.id}
                          ref={this.pmTableRef}
                          onIssuesListChange={() => {
                            // Custom functionality when issues list changes
                            this.handleSearchData();
                          }}
                        />
                      </div>
                    </div>
                  );
                }

                // Render the DOT Inspection-related view when DOT Inspections are expanded
                if (isSafetyExpanded) {
                  return (
                    <div className="safety-inspection-wrapper">
                      <PMTable
                        ref={this.pmTableRef}
                        carId={car.id}
                        onIssuesListChange={() => {
                          // Custom functionality when issues list changes
                          this.handleSearchData();
                        }}
                        isSafetyInspection={true}
                      />
                    </div>
                  );
                }

                if (isWorkOrderExpanded) {
                  return (
                    <div className="work-order-wrapper">
                      <WorkOrderTable
                        onHistoryPush={(path) => {
                          this.props.history.push(path);
                        }}
                        shopId={this.state.shopId}
                        isSelectionEnabled={true}
                        isEditable={false}
                        hideDealershipChooser={true}
                        hideAssignedWidget={true}
                        expandColumnSizes={true}
                        assetIdToFilterByDefault={car.id}
                      />
                    </div>
                  );
                }
                // Otherwise, render the IssuesTable as default
                return (
                  <div className="issues-table-wrapper">
                    <IssuesTable
                      refs={(ref) => {
                        this.mapIssuesTable[car.id] = ref;
                      }}
                      isEnabled={!_.isNil(car.id)}
                      id={`car-${car.id}`}
                      fetchData={(params, store) => {
                        IssueStore.getIssuesForCarId(
                          {
                            ...params,
                          },
                          store,
                          car.id
                        );
                      }}
                      onIssuesListChange={() => {
                        this.handleSearchData();
                      }}
                      page="carPage"
                    />
                  </div>
                );
              }}
              expandedRowKeys={[
                ...this.state.expandedCarIds,
                ...this.state.expandedPMCarIds,
                ...this.state.expandedSafetyInspectionIds,
                ...this.state.expandedWorkOrderCarIds,
              ]}
              expandIconAsCell={false}
              expandIconColumnIndex={-1}
              onExpand={(expanded, record) => {
                if (this.state.expandedPMCarIds.includes(record.id)) {
                  // Handle PM toggle
                  this.handleCarPMsToggle(record);
                } else if (
                  this.state.expandedSafetyInspectionIds.includes(record.id)
                ) {
                  // Handle Safety PM toggle
                  this.handleSafetyInspectionToggle(record);
                } else if (
                  this.state.expandedWorkOrderCarIds.includes(record.id)
                ) {
                  // Handle Work Order toggle
                  this.handleCarWorkOrdersToggle(record.id);
                } else {
                  // Handle Issues toggle
                  this.handleCarIssuesToggle(record);
                }
              }}
              components={{
                header: {
                  cell: CustomHeaderCell,
                },
                body: {
                  wrapper: (props) => (
                    <tbody {...props}>
                      {this.state.allRecordsRowOption &&
                        this.state.selectedAssets?.length === 10 && (
                          <FullWidthRow>
                            <td colSpan={newColumns?.length + 1}>
                              {this.state.selectAll ? (
                                <SelectAll
                                  totalCount={this.state.paginationMeta.total}
                                  onClearSelection={this.clearSelection}
                                />
                              ) : (
                                <SelectPartial
                                  selectedCount={
                                    this.state.selectedAssets?.length
                                  }
                                  totalCount={this.state.paginationMeta.total}
                                  onSelectAll={this.selectAll}
                                />
                              )}
                            </td>
                          </FullWidthRow>
                        )}
                      {props.children}
                    </tbody>
                  ),
                },
              }}
              enableStickyHeader={true}
              scroll={{ x: 1500 }}
            />
          </div>
        )}

        <AddAssetModal
          visible={AppStore.openModals.get('ADD_ASSET_MODAL') || false}
          type="trailer"
          onOk={this.onAddAsset}
          onCancel={() => {
            AppStore.openModals.set('ADD_ASSET_MODAL', false);
          }}
        />

        <StyledPitstopModal
          isVisible={this.state.showShopAssetStatusesModal}
          okButtonProps={{ loading: this.state.isSavingStatuses }}
          onOk={this.saveNewShopStatuses}
          onCancel={() => {
            // AppStore.openModals.set('SHOP_STATUSES_MODAL', false);
            this.setState({
              showShopAssetStatusesModal: false,
            });
          }}
          title="Edit Status Options"
          width={800}
          closable
        >
          <div className="status-description">
            You can change the color or name of each status, add or remove
            statuses, and designate specific functions associated with each
            status
          </div>

          <table border={1} style={{ width: '100%', borderColor: '#fefefe' }}>
            <thead>
              <tr>
                <th colSpan={2} style={{ minWidth: '350px' }}>
                  &nbsp;
                </th>
                <th style={{ textAlign: 'center' }}>Set as Default</th>
                <th style={{ textAlign: 'center' }}>Set Vendor dropdown</th>
                <th style={{ textAlign: 'center' }}>Set as Running</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody style={{ lineHeight: 'calc(1em + 4px)' }}>
              {this.state.newShopCarStatuses.map((status, index) => (
                <tr key={status.key} style={{ marginBottom: '4px' }}>
                  <td colSpan={2} style={{ paddingBottom: '4px' }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        marginBottom: '4px',
                      }}
                    >
                      <input
                        type="color"
                        value={status.color}
                        id={`color-picker-${status.id}`}
                        name={`color-picker-${status.id}`}
                        onChange={(e) => {
                          status.color = e.target.value;
                          this.setState({
                            newShopCarStatuses: this.state.newShopCarStatuses,
                          });
                        }}
                        style={{ marginBottom: '4px' }}
                      />
                      <Input
                        id={`description-new-${index + 1}`}
                        placeholder="Insert new status name..."
                        value={status.description}
                        onChange={(e) => {
                          status.description = e.target.value;
                          this.setState({
                            newShopCarStatuses: this.state.newShopCarStatuses,
                          });
                        }}
                        style={{ marginBottom: '4px' }}
                      />
                    </div>
                  </td>
                  <td style={{ textAlign: 'center', paddingBottom: '4px' }}>
                    <Checkbox
                      checked={status.is_default}
                      onChange={(e) =>
                        this.toggleSelectStatusByDefault(
                          e,
                          status.key,
                          status.is_default
                        )
                      }
                      style={{ marginBottom: '4px' }}
                    />
                  </td>
                  <td style={{ textAlign: 'center', paddingBottom: '4px' }}>
                    <Checkbox
                      checked={status.is_show_vendor}
                      onChange={(e) =>
                        this.toggleStatusToShowVendors(
                          e,
                          status.key,
                          status.is_show_vendor
                        )
                      }
                      style={{ marginBottom: '4px' }}
                    />
                  </td>
                  <td style={{ textAlign: 'center', paddingBottom: '4px' }}>
                    <Checkbox
                      checked={status.is_status_running}
                      onChange={(e) =>
                        this.toggleStatusRunning(
                          e,
                          status.key,
                          status.is_status_running
                        )
                      }
                      style={{ marginBottom: '4px' }}
                    />
                  </td>
                  <td style={{ textAlign: 'center', paddingBottom: '4px' }}>
                    <Popconfirm
                      title="Are you sure you want to delete this status?"
                      onConfirm={() => {
                        this.setState(
                          {
                            newShopCarStatuses:
                              this.state.newShopCarStatuses.filter(
                                (s) => s.key !== status.key
                              ),
                          },
                          () => {
                            // if there's no default status, set the first one as default
                            if (
                              !_.some(this.state.newShopCarStatuses, {
                                is_default: true,
                              })
                            ) {
                              this.setState({
                                newShopCarStatuses:
                                  this.state.newShopCarStatuses.map(
                                    (status, index) => {
                                      if (index === 0) {
                                        status.is_selected = true;
                                        status.is_default = true;
                                      }
                                      return status;
                                    }
                                  ),
                              });
                            }
                          }
                        );
                      }}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button
                        type="danger"
                        icon={<DeleteOutlined />}
                        style={{ color: 'red', marginBottom: '4px' }}
                      />
                    </Popconfirm>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <Button
            icon={<PlusOutlined />}
            type="primary"
            ghost
            onClick={() => {
              this.state.newShopCarStatuses.push({
                key: `new-${this.state.newShopCarStatuses?.length + 1}`,
                color: '#CFCFCF',
              });
              this.setState(
                { newShopCarStatuses: this.state.newShopCarStatuses },
                () => {
                  // focus on the last item
                  setTimeout(() => {
                    document
                      .getElementById(
                        `description-new-${this.state.newShopCarStatuses?.length}`
                      )
                      .focus();
                  }, 10);
                }
              );
            }}
          >
            Create New Status
          </Button>
        </StyledPitstopModal>

        <PitstopModal
          id={'HEALTH_REPORT_MODAL_ID'}
          title=""
          width={700}
          onOk={() => {
            AppStore.openModals.set('HEALTH_REPORT_MODAL_ID', false);
            if (this.state.isPrintHealthReport) {
              return this.onPrintVehicleHealthReport();
            }
            this.onDownloadVehicleHealthReport();
          }}
          onCancel={() =>
            AppStore.openModals.set('HEALTH_REPORT_MODAL_ID', false)
          }
        >
          <Row>
            <h3>Please select report's format:</h3>
          </Row>

          <Row gutter={[16, 16]}>
            <Col span={24}>
              <b>Issues Status</b>
              <Checkbox.Group
                style={{ width: '100%' }}
                value={this.state.issueReportStatus}
                onChange={(values) => {
                  this.setState({ issueReportStatus: values });
                }}
              >
                <Row>
                  {_.map(statusOptions, (status) => (
                    <Col key={status.value} span={8}>
                      <Checkbox value={status.value}>{status.label}</Checkbox>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
            </Col>

            <Col span={24}>
              <b>Issues Sources</b>
              <Checkbox.Group
                style={{ width: '100%' }}
                value={this.state.issueSources}
                onChange={(values) => {
                  this.setState({ issueSources: values });
                }}
              >
                <Row>
                  {_.map(sourceOptions, (source) => (
                    <Col key={source.value} span={12}>
                      <Checkbox value={source.value}>{source.label}</Checkbox>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
            </Col>
          </Row>
        </PitstopModal>

        <PitstopModal
          okButtonProps={{ style: { display: 'none' } }}
          onOk={() => {}}
          onCancel={() => {
            AppStore.openModals.set('SHARE_VEHICLE_HEALTH_REPORT_MODAL', false);
          }}
          afterClose={() => {
            if (this.shareVHRCallables && this.shareVHRCallables.resetForm) {
              this.shareVHRCallables.resetForm();
            }
          }}
          title=""
          width={800}
          id="SHARE_VEHICLE_HEALTH_REPORT_MODAL"
        >
          <ShareVehicleHealthReportPage
            selectedCarId={this.state.selectedCarId}
            setParentCallables={(callables) => {
              this.shareVHRCallables = callables;
            }}
          />
        </PitstopModal>

        <ArchiveAssetModal
          visible={this.state.isArchiveAssetsModalVisible}
          isArchiving={this.state.isArchivingAssets}
          onCancel={() => {
            this.setState({ isArchiveAssetsModalVisible: false });
          }}
          onOk={(notes) => {
            this.handleArchiveAssets(notes);
          }}
        />

        {/* Sub-location selection modal */}
        <SubLocationSelectionModal
          carIds={this.state.subLocationModalCarIds}
          visible={this.state.subLocationModalVisible}
          onClose={() => this.setState({ subLocationModalVisible: false })}
          onSuccess={(selectedNewSubLocation) => {
            // refresh the table
            this.setState({
              subLocationModalVisible: false,
              currentVehicles: this.state.currentVehicles.map((ccar) => {
                if (this.state.subLocationModalCarIds.includes(ccar.id)) {
                  ccar.meta = {
                    ...ccar.meta,
                    assetLocationId: selectedNewSubLocation || null,
                  };
                }
                return ccar;
              }),
            });
          }}
        />
      </IndicatorTableWrapper>
    );
  }
}

export default withRouter(observer(VehiclesTable));

function SelectPartial({ selectedCount, totalCount, onSelectAll }) {
  return (
    <>
      {selectedCount} selected on this page.{' '}
      <a onClick={onSelectAll}>
        Select all {totalCount} applicable assets instead.
      </a>{' '}
      (Only assets matching the applied filters are available for selection)
    </>
  );
}

function SelectAll({ totalCount, onClearSelection }) {
  return (
    <>
      All {totalCount} assets in your fleet are selected.{' '}
      <a onClick={onClearSelection}>Clear selection</a>
    </>
  );
}

const EditableColumnTitle = ({ title, onSave, onDelete }) => {
  const [visible, setVisible] = useState(false);
  const [inputValue, setInputValue] = useState(title);

  const content = (
    <div>
      <Input
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder="Enter Column Label"
        style={{ marginBottom: 8 }}
      />
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Popconfirm
          title={
            <>
              Are you sure you want to delete this column?
              <br />
              All your data will be lost.
            </>
          }
          okText="Yes"
          cancelText="No"
          onConfirm={onDelete}
        >
          <Button type="link" danger>
            Delete Column
          </Button>
        </Popconfirm>
        <div>
          <Button
            type="link"
            onClick={() => {
              setInputValue(title);
              setVisible(false);
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={() => {
              onSave(inputValue);
              setVisible(false);
            }}
          >
            OK
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <Popover
      content={content}
      trigger="click"
      open={visible}
      onOpenChange={setVisible}
    >
      <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
        <Typography.Text>{title}</Typography.Text>
        <EditOutlined style={{ cursor: 'pointer' }} />
      </div>
    </Popover>
  );
};
